import { buildBasicOrganizationConnectionRecord, buildOrganizationConnectionProjection, } from "./connection.js";
import { allEntitlements, platformFeeComponentDefaultRuleId, platformFeeGlobalFallbackRuleId, platformFeeOrganizationOverrideRuleId, } from "./billing.js";
import { approvedIslamicComponentDefinitions, buildDefaultOrganizationIslamicComponentConfig, } from "./islamicComponents.js";
import { buildRamadanIftarDaysFromDefaults, } from "./iftarSponsorship.js";
import { emptyCommerceRequirementsSummary, } from "./commerce.js";
import { buildOrganizationDirectoryProfile } from "./organization.js";
import { buildOrganizationRoleAssignment, buildOrganizationRoleAssignmentAuditEvent, } from "./roles.js";
import { defaultSpaceOperatingHours, } from "./spaces.js";
export const firebaseProjects = {
    development: "demo-shdeed-dev",
    staging: "shdeed-staging",
    production: "shdeed-prod",
};
export const developmentPassword = "ShdeedDev!12345";
function foundationModuleReadiness() {
    return {
        announcements: "placeholder",
        commerce: "placeholder",
        events: "placeholder",
        prayer: "placeholder",
        ramadan: "placeholder",
        spaces: "placeholder",
        volunteers: "placeholder",
    };
}
function foundationConfigVersions() {
    return {
        branding: 1,
        private: 1,
        public: 1,
    };
}
const hviccOrganization = {
    address: {
        city: "Huntingdon Valley",
        country: "US",
        line1: null,
        line2: null,
        postalCode: "19006",
        region: "PA",
        summary: "Huntingdon Valley, PA",
    },
    brandColor: "#116466",
    branding: {
        accentColor: "#d8b45f",
        coverImageStoragePath: null,
        displayName: "HVICC",
        logoStoragePath: null,
        primaryColor: "#116466",
        secondaryColor: "#0b3f42",
        updatedAt: "development-seed",
        version: 1,
    },
    city: "Huntingdon Valley, PA",
    configVersions: foundationConfigVersions(),
    country: "US",
    createdAt: "development-seed",
    currency: "USD",
    defaultLocale: "en",
    displayName: "HVICC",
    id: "org-hvicc",
    legalName: null,
    migration: {
        globalConfigMapping: "deferred_org_scoped_settings",
        legacyFirebaseProjectId: "hvicc-76804",
        legacySource: "hvicc_existing_app",
        syntheticSeed: true,
    },
    moduleReadiness: foundationModuleReadiness(),
    organizationId: "org-hvicc",
    organizationType: "islamic_center",
    primaryCampusId: "campus-hvicc-main",
    publicContact: {
        email: null,
        phone: null,
        socialLinks: [],
        websiteUrl: null,
    },
    publicVisibility: {
        directory: true,
        discovery: true,
        profile: true,
    },
    source: {
        createdBy: "seed:development",
        environment: "development",
        origin: "development_seed",
    },
    status: "active",
    supportedLocales: ["en", "ar"],
    template: {
        id: "shdeed_foundation",
        version: 1,
    },
    timeZone: "America/New_York",
    updatedAt: "development-seed",
};
const rahmaOrganization = {
    address: {
        city: "Allentown",
        country: "US",
        line1: null,
        line2: null,
        postalCode: "18101",
        region: "PA",
        summary: "Allentown, PA",
    },
    brandColor: "#7a4eab",
    branding: {
        accentColor: "#f0b45a",
        coverImageStoragePath: null,
        displayName: "Rahma Community Center",
        logoStoragePath: null,
        primaryColor: "#7a4eab",
        secondaryColor: "#264653",
        updatedAt: "development-seed",
        version: 1,
    },
    city: "Allentown, PA",
    configVersions: foundationConfigVersions(),
    country: "US",
    createdAt: "development-seed",
    currency: "USD",
    defaultLocale: "en",
    displayName: "Rahma Community Center",
    id: "org-rahma",
    legalName: null,
    migration: {
        globalConfigMapping: "not_applicable",
        legacyFirebaseProjectId: null,
        legacySource: null,
        syntheticSeed: true,
    },
    moduleReadiness: foundationModuleReadiness(),
    organizationId: "org-rahma",
    organizationType: "other_nonprofit",
    primaryCampusId: "campus-rahma-main",
    publicContact: {
        email: null,
        phone: null,
        socialLinks: [],
        websiteUrl: null,
    },
    publicVisibility: {
        directory: true,
        discovery: true,
        profile: true,
    },
    source: {
        createdBy: "seed:development",
        environment: "development",
        origin: "development_seed",
    },
    status: "active",
    supportedLocales: ["en", "ar"],
    template: {
        id: "shdeed_foundation",
        version: 1,
    },
    timeZone: "America/New_York",
    updatedAt: "development-seed",
};
export const seedOrganizations = [hviccOrganization, rahmaOrganization];
function planEntitlements(enabledEntitlements) {
    const entitlements = allEntitlements(false);
    for (const entitlementId of enabledEntitlements) {
        entitlements[entitlementId] = true;
    }
    return entitlements;
}
function planCatalogRecord(input) {
    return {
        billingInterval: input.billingInterval,
        createdAt: "development-seed",
        currency: "usd",
        defaultEntitlements: planEntitlements(input.enabledEntitlements),
        defaultLimits: {
            cloudAiMonthlyActions: input.cloudAiMonthlyActions,
            organizationLocations: input.organizationLocations,
            storageBytes: input.storageBytes,
        },
        defaultPlatformFeePolicyId: "default-zero-commerce-fee",
        displayName: input.displayName,
        displayNameAr: input.displayNameAr,
        id: input.planId,
        planId: input.planId,
        priceMinor: input.priceMinor,
        source: "experience_thirty",
        status: "active",
        trial: {
            defaultDays: input.trialDefaultDays,
            eligible: input.trialEligible,
            targetPlanId: input.trialEligible ? input.planId : null,
        },
        updatedAt: "development-seed",
        version: 1,
    };
}
const coreOperationalEntitlements = [
    "community.core",
    "communications.basic",
    "events.core",
    "events.qrCheckIn",
    "commerce.donations",
    "commerce.campaigns",
    "ramadan.operations",
    "operations.modes",
    "spaces.core",
    "directory.management",
];
const advancedEventEntitlements = [
    "events.advancedRegistration",
    "events.exports",
];
export const demoOrganizationPlanCatalog = [
    planCatalogRecord({
        billingInterval: "free",
        cloudAiMonthlyActions: 0,
        displayName: "Community",
        displayNameAr: "المجتمع",
        enabledEntitlements: coreOperationalEntitlements,
        organizationLocations: 1,
        planId: "community",
        priceMinor: 0,
        storageBytes: 1_073_741_824,
        trialDefaultDays: 0,
        trialEligible: false,
    }),
    planCatalogRecord({
        billingInterval: "month",
        cloudAiMonthlyActions: 0,
        displayName: "Grow",
        displayNameAr: "النمو",
        enabledEntitlements: [
            ...coreOperationalEntitlements,
            ...advancedEventEntitlements,
            "volunteers.core",
        ],
        organizationLocations: 2,
        planId: "grow",
        priceMinor: 7_900,
        storageBytes: 10_737_418_240,
        trialDefaultDays: 14,
        trialEligible: true,
    }),
    planCatalogRecord({
        billingInterval: "month",
        cloudAiMonthlyActions: 2_500,
        displayName: "Impact",
        displayNameAr: "الأثر",
        enabledEntitlements: [
            ...coreOperationalEntitlements,
            ...advancedEventEntitlements,
            "communications.advanced",
            "events.paid",
            "volunteers.core",
            "analytics.advanced",
            "ai.cloud",
        ],
        organizationLocations: 5,
        planId: "impact",
        priceMinor: 19_900,
        storageBytes: 53_687_091_200,
        trialDefaultDays: 14,
        trialEligible: true,
    }),
    planCatalogRecord({
        billingInterval: "month",
        cloudAiMonthlyActions: 10_000,
        displayName: "Network",
        displayNameAr: "الشبكة",
        enabledEntitlements: [
            ...coreOperationalEntitlements,
            ...advancedEventEntitlements,
            "communications.advanced",
            "events.paid",
            "volunteers.core",
            "analytics.advanced",
            "ai.cloud",
            "network.multiSite",
        ],
        organizationLocations: 25,
        planId: "network",
        priceMinor: 49_900,
        storageBytes: 214_748_364_800,
        trialDefaultDays: 14,
        trialEligible: true,
    }),
];
export const demoPlatformFeePolicies = [
    {
        applicableTransactionTypes: ["donation", "spaceRental", "ramadanSponsorship"],
        basisPoints: 0,
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Default zero commerce fee",
        effectiveFrom: "development-seed",
        effectiveUntil: null,
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: "default-zero-commerce-fee",
        maximumMinor: null,
        minimumMinor: null,
        policyId: "default-zero-commerce-fee",
        source: "experience_thirty",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
];
export const demoPlatformFeeRules = [
    {
        basisPoints: 0,
        collectionMode: "deductFromOrg",
        component: null,
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development global fallback fee",
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: platformFeeGlobalFallbackRuleId(),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: null,
        ruleId: platformFeeGlobalFallbackRuleId(),
        scope: "platformFallback",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
    {
        basisPoints: 0,
        collectionMode: "deductFromOrg",
        component: "generalDonation",
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development general donation fee",
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: platformFeeComponentDefaultRuleId("generalDonation"),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: null,
        ruleId: platformFeeComponentDefaultRuleId("generalDonation"),
        scope: "componentDefault",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
    {
        basisPoints: 0,
        collectionMode: "deductFromOrg",
        component: "campaignDonation",
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development campaign donation fee",
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: platformFeeComponentDefaultRuleId("campaignDonation"),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: null,
        ruleId: platformFeeComponentDefaultRuleId("campaignDonation"),
        scope: "componentDefault",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
    {
        basisPoints: 0,
        collectionMode: "deductFromOrg",
        component: "iftarSponsorship",
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development Iftar sponsorship fee",
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: platformFeeComponentDefaultRuleId("iftarSponsorship"),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: null,
        ruleId: platformFeeComponentDefaultRuleId("iftarSponsorship"),
        scope: "componentDefault",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
    {
        basisPoints: 25,
        collectionMode: "addOnToPayer",
        component: "spaceBooking",
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development Space booking fee",
        enabled: true,
        feeType: "basisPoints",
        fixedMinor: 0,
        id: platformFeeComponentDefaultRuleId("spaceBooking"),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: null,
        ruleId: platformFeeComponentDefaultRuleId("spaceBooking"),
        scope: "componentDefault",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
    {
        basisPoints: 0,
        collectionMode: "deductFromOrg",
        component: "spaceBooking",
        createdAt: "development-seed",
        currency: "usd",
        displayName: "Development Rahma Space fee override",
        enabled: true,
        feeType: "none",
        fixedMinor: 0,
        id: platformFeeOrganizationOverrideRuleId({
            component: "spaceBooking",
            organizationId: "org-rahma",
        }),
        maximumMinor: null,
        minimumMinor: null,
        organizationId: "org-rahma",
        ruleId: platformFeeOrganizationOverrideRuleId({
            component: "spaceBooking",
            organizationId: "org-rahma",
        }),
        scope: "organizationOverride",
        source: "commerce_v1",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
];
export const demoOrganizationSubscriptionConfigs = [
    {
        billingState: "active",
        createdAt: "development-seed",
        effectiveEntitlementsVersion: 1,
        effectiveSubscriptionDiscountBasisPoints: 5_000,
        foundingDiscountBasisPoints: 5_000,
        foundingSlotNumber: 1,
        foundingStatus: "active",
        id: "subscription",
        organizationId: "org-hvicc",
        planId: "grow",
        source: "experience_thirty",
        status: "active",
        trialEndsAt: null,
        trialStartedAt: null,
        trialStatus: "none",
        trialTargetPlanId: null,
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
    {
        billingState: "none",
        createdAt: "development-seed",
        effectiveEntitlementsVersion: 1,
        effectiveSubscriptionDiscountBasisPoints: 0,
        foundingDiscountBasisPoints: 0,
        foundingSlotNumber: null,
        foundingStatus: "none",
        id: "subscription",
        organizationId: "org-rahma",
        planId: "community",
        source: "experience_thirty",
        status: "free",
        trialEndsAt: null,
        trialStartedAt: null,
        trialStatus: "eligible",
        trialTargetPlanId: "grow",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const demoOrganizationEntitlementOverrides = [
    {
        entitlementId: "ai.cloud",
        id: "ai.cloud",
        mode: "forceDisabled",
        organizationId: "org-hvicc",
        reason: "Cloud AI remains disabled for the development HVICC Grow seed until explicit owner approval.",
        source: "experience_thirty",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const demoOrganizationUsageLimitSnapshots = [
    {
        canUploadStorage: true,
        cloudAiMonthlyActionsLimit: 0,
        cloudAiMonthlyActionsUsed: 0,
        id: "current",
        organizationId: "org-hvicc",
        organizationLocationsLimit: 2,
        organizationLocationsUsed: 1,
        source: "experience_thirty",
        storageBytesLimit: 10_737_418_240,
        storageBytesUsed: 268_435_456,
        storageStatus: "underLimit",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
    {
        canUploadStorage: true,
        cloudAiMonthlyActionsLimit: 0,
        cloudAiMonthlyActionsUsed: 0,
        id: "current",
        organizationId: "org-rahma",
        organizationLocationsLimit: 1,
        organizationLocationsUsed: 1,
        source: "experience_thirty",
        storageBytesLimit: 1_073_741_824,
        storageBytesUsed: 67_108_864,
        storageStatus: "underLimit",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const demoFoundingOrganizationSlots = [
    {
        discountBasisPoints: 5_000,
        id: "org-hvicc",
        immutableQualificationReason: "HVICC is reserved as the first development founding organization for launch readiness validation.",
        organizationId: "org-hvicc",
        qualifiedAt: "development-seed",
        qualifiedBy: "dev-platform-super-admin",
        slotNumber: 1,
        source: "experience_thirty",
        status: "active",
        updatedAt: "development-seed",
    },
];
export const demoPlatformBillingCounters = [
    {
        activeSlotCount: demoFoundingOrganizationSlots.filter((slot) => slot.status === "active")
            .length,
        id: "founding100",
        maxSlots: 100,
        source: "experience_thirty",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const seedOrganizationCampuses = [
    {
        accessibility: {
            notes: null,
            status: "not_configured",
            wheelchairAccessible: null,
        },
        address: hviccOrganization.address,
        campusId: "campus-hvicc-main",
        createdAt: "development-seed",
        geo: {
            latitude: null,
            longitude: null,
        },
        id: "campus-hvicc-main",
        name: "HVICC Main Campus",
        operatingHours: {
            status: "not_configured",
        },
        organizationId: "org-hvicc",
        publicContact: hviccOrganization.publicContact,
        source: hviccOrganization.source,
        status: "active",
        timeZoneOverride: null,
        updatedAt: "development-seed",
    },
    {
        accessibility: {
            notes: null,
            status: "not_configured",
            wheelchairAccessible: null,
        },
        address: rahmaOrganization.address,
        campusId: "campus-rahma-main",
        createdAt: "development-seed",
        geo: {
            latitude: null,
            longitude: null,
        },
        id: "campus-rahma-main",
        name: "Rahma Main Campus",
        operatingHours: {
            status: "not_configured",
        },
        organizationId: "org-rahma",
        publicContact: rahmaOrganization.publicContact,
        source: rahmaOrganization.source,
        status: "active",
        timeZoneOverride: null,
        updatedAt: "development-seed",
    },
];
export const seedOrganizationConfigDocuments = [
    {
        configDocument: "foundation",
        configVersions: foundationConfigVersions(),
        connectionPolicy: "open",
        createdAt: "development-seed",
        id: "foundation",
        legacyGlobalConfigImport: "deferred",
        moduleReadiness: foundationModuleReadiness(),
        organizationId: "org-hvicc",
        templateId: "shdeed_foundation",
        templateVersion: 1,
        updatedAt: "development-seed",
        validationSettings: {
            testCode: null,
        },
    },
    {
        configDocument: "foundation",
        configVersions: foundationConfigVersions(),
        connectionPolicy: "approvalRequired",
        createdAt: "development-seed",
        id: "foundation",
        legacyGlobalConfigImport: "deferred",
        moduleReadiness: foundationModuleReadiness(),
        organizationId: "org-rahma",
        templateId: "shdeed_foundation",
        templateVersion: 1,
        updatedAt: "development-seed",
        validationSettings: {
            testCode: "RAHMA-VALIDATED",
        },
    },
];
export const demoPlatformIslamicComponents = approvedIslamicComponentDefinitions;
export const demoOrganizationIslamicComponentConfigs = [
    buildDefaultOrganizationIslamicComponentConfig({
        organizationId: "org-hvicc",
        timestamp: "development-seed",
        updatedBy: "development-seed",
    }),
    buildDefaultOrganizationIslamicComponentConfig({
        disabledComponentIds: ["hadith", "dailyHadith", "duas", "dailyDua"],
        organizationId: "org-rahma",
        timestamp: "development-seed",
        updatedBy: "development-seed",
    }),
];
export const publicOrganizationProfiles = [
    buildOrganizationDirectoryProfile(hviccOrganization, {
        category: "Islamic center",
        connectionPolicy: "open",
        welcomeHeadline: "A community home for prayer, learning, and service.",
        welcomeHeadlineAr: "بيت مجتمعي للصلاة والتعلم والخدمة.",
        welcomeSummary: "Discover HVICC updates, prayer-time context, Ramadan operations, and community services as Shdeed comes online.",
        welcomeSummaryAr: "استكشف تحديثات HVICC وأوقات الصلاة وسير رمضان وخدمات المجتمع مع انطلاق شديد.",
    }),
    buildOrganizationDirectoryProfile(rahmaOrganization, {
        category: "Community center",
        connectionPolicy: "approval_required",
        welcomeHeadline: "A welcoming space for families, volunteers, and neighbors.",
        welcomeHeadlineAr: "مساحة ترحيبية للعائلات والمتطوعين والجيران.",
        welcomeSummary: "Follow Rahma's early Shdeed setup while the team prepares community programs and operational tools.",
        welcomeSummaryAr: "تابع إعداد رحمة الأولي في شديد بينما يجهز الفريق البرامج والأدوات التشغيلية.",
    }),
];
export const demoBusinessDirectoryCategories = [
    {
        categoryId: "halal-food",
        createdAt: "development-seed",
        displayOrder: 10,
        id: "halal-food",
        label: "Halal food",
        labelAr: "طعام حلال",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
    },
    {
        categoryId: "professional-services",
        createdAt: "development-seed",
        displayOrder: 20,
        id: "professional-services",
        label: "Professional services",
        labelAr: "خدمات مهنية",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
    },
    {
        categoryId: "education",
        createdAt: "development-seed",
        displayOrder: 30,
        id: "education",
        label: "Education",
        labelAr: "تعليم",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
    },
    {
        categoryId: "community-services",
        createdAt: "development-seed",
        displayOrder: 40,
        id: "community-services",
        label: "Community services",
        labelAr: "خدمات مجتمعية",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
    },
];
export const demoBusinessDirectoryBusinesses = [
    {
        affiliationsSummary: {
            activeOrganizationCount: 2,
            activeOrganizationIds: ["org-hvicc", "org-rahma"],
        },
        businessId: "hudson-halal-market",
        categoryIds: ["halal-food", "community-services"],
        contact: {
            email: "hello@hudsonhalal.example.test",
            phone: "+1 845 555 0110",
            websiteUrl: "https://hudsonhalal.example.test",
        },
        createdAt: "development-seed",
        createdBy: "dev-platform-super-admin",
        description: "Local halal groceries and catering support for masjid events, pantry drives, and Ramadan programs.",
        descriptionAr: "مواد غذائية حلال محلية ودعم للتموين في فعاليات المساجد وحملات السلة وبرامج رمضان.",
        featured: {
            endsAt: null,
            isFeatured: true,
            priority: 10,
            startsAt: "development-seed",
            updatedAt: "development-seed",
            updatedBy: "dev-platform-super-admin",
        },
        id: "hudson-halal-market",
        location: {
            addressLine1: "100 Main Street",
            addressLine2: null,
            city: "Newburgh",
            country: "US",
            geo: {
                latitude: 41.5034,
                longitude: -74.0104,
            },
            postalCode: "12550",
            region: "NY",
        },
        logo: {
            altText: "Hudson Halal Market logo",
            altTextAr: "شعار سوق هدسون الحلال",
            storagePath: "businesses/hudson-halal-market/logo.png",
        },
        name: "Hudson Halal Market",
        nameAr: "سوق هدسون الحلال",
        publicVisibility: {
            directory: true,
            discovery: true,
        },
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "dev-platform-super-admin",
        verification: {
            revokedAt: null,
            revokedBy: null,
            state: "verified",
            verifiedAt: "development-seed",
            verifiedBy: "dev-platform-super-admin",
        },
    },
    {
        affiliationsSummary: {
            activeOrganizationCount: 1,
            activeOrganizationIds: ["org-hvicc"],
        },
        businessId: "family-learning-studio",
        categoryIds: ["education", "professional-services"],
        contact: {
            email: "programs@familylearning.example.test",
            phone: "+1 845 555 0188",
            websiteUrl: "https://familylearning.example.test",
        },
        createdAt: "development-seed",
        createdBy: "dev-platform-super-admin",
        description: "Tutoring and weekend enrichment programs for families looking for local academic support.",
        descriptionAr: "دروس تقوية وبرامج إثراء أسبوعية للعائلات الباحثة عن دعم أكاديمي محلي.",
        featured: {
            endsAt: null,
            isFeatured: false,
            priority: 100,
            startsAt: null,
            updatedAt: null,
            updatedBy: null,
        },
        id: "family-learning-studio",
        location: {
            addressLine1: null,
            addressLine2: null,
            city: "Poughkeepsie",
            country: "US",
            geo: {
                latitude: null,
                longitude: null,
            },
            postalCode: null,
            region: "NY",
        },
        logo: null,
        name: "Family Learning Studio",
        nameAr: "استوديو تعلم الأسرة",
        publicVisibility: {
            directory: true,
            discovery: true,
        },
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "dev-platform-super-admin",
        verification: {
            revokedAt: null,
            revokedBy: null,
            state: "verified",
            verifiedAt: "development-seed",
            verifiedBy: "dev-platform-super-admin",
        },
    },
    {
        affiliationsSummary: {
            activeOrganizationCount: 0,
            activeOrganizationIds: [],
        },
        businessId: "private-review-only",
        categoryIds: ["professional-services"],
        contact: {
            email: null,
            phone: null,
            websiteUrl: null,
        },
        createdAt: "development-seed",
        createdBy: "dev-platform-super-admin",
        description: "Draft directory entry used to verify hidden records stay private.",
        descriptionAr: "إدخال مسودة للتحقق من بقاء السجلات غير المنشورة خاصة.",
        featured: {
            endsAt: null,
            isFeatured: false,
            priority: 999,
            startsAt: null,
            updatedAt: null,
            updatedBy: null,
        },
        id: "private-review-only",
        location: {
            addressLine1: null,
            addressLine2: null,
            city: "Newburgh",
            country: "US",
            geo: {
                latitude: null,
                longitude: null,
            },
            postalCode: null,
            region: "NY",
        },
        logo: null,
        name: "Private Review Only",
        nameAr: null,
        publicVisibility: {
            directory: false,
            discovery: false,
        },
        source: "experience_forty_four",
        status: "draft",
        updatedAt: "development-seed",
        updatedBy: "dev-platform-super-admin",
        verification: {
            revokedAt: null,
            revokedBy: null,
            state: "unverified",
            verifiedAt: null,
            verifiedBy: null,
        },
    },
];
export const demoBusinessOrganizationAffiliations = [
    {
        affiliationId: "hudson-halal-market_org-hvicc",
        affiliationType: "recommended",
        businessId: "hudson-halal-market",
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        displayOrder: 10,
        organizationId: "org-hvicc",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
    },
    {
        affiliationId: "hudson-halal-market_org-rahma",
        affiliationType: "listed",
        businessId: "hudson-halal-market",
        createdAt: "development-seed",
        createdBy: "dev-rahma-owner",
        displayOrder: 20,
        organizationId: "org-rahma",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "dev-rahma-owner",
    },
    {
        affiliationId: "family-learning-studio_org-hvicc",
        affiliationType: "partner",
        businessId: "family-learning-studio",
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        displayOrder: 30,
        organizationId: "org-hvicc",
        source: "experience_forty_four",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
    },
];
export const demoOrganizationBusinessAffiliationProjections = demoBusinessOrganizationAffiliations.map((affiliation) => {
    const business = demoBusinessDirectoryBusinesses.find((entry) => entry.businessId === affiliation.businessId);
    if (!business) {
        throw new Error(`Missing seeded business for affiliation ${affiliation.affiliationId}.`);
    }
    return {
        ...affiliation,
        businessCategoryIdsSnapshot: [...business.categoryIds],
        businessNameArSnapshot: business.nameAr,
        businessNameSnapshot: business.name,
        businessVerificationStateSnapshot: business.verification.state,
    };
});
export const demoBusinessDirectoryAuditEvents = [
    {
        action: "business_verified",
        actorUid: "dev-platform-super-admin",
        businessId: "hudson-halal-market",
        createdAt: "development-seed",
        eventId: "hudson-halal-market-platform-business_verified-seed",
        organizationId: null,
        source: "experience_forty_four",
        status: "completed",
        summary: "Verified Hudson Halal Market for the cross-tenant business directory seed.",
    },
    {
        action: "business_affiliation_set",
        actorUid: "dev-hvicc-admin",
        businessId: "hudson-halal-market",
        createdAt: "development-seed",
        eventId: "hudson-halal-market-org-hvicc-business_affiliation_set-seed",
        organizationId: "org-hvicc",
        source: "experience_forty_four",
        status: "completed",
        summary: "Linked Hudson Halal Market to HVICC as a recommended business.",
    },
];
export const seedPeople = [
    {
        uid: "dev-prospect",
        umid: "umid_00000000000000000000000001",
        email: "prospect@example.test",
        displayName: "Prospective Member",
        locale: "en",
        connections: [],
    },
    {
        uid: "dev-rahma-owner",
        umid: "umid_00000000000000000000000012",
        email: "rahma.owner@example.test",
        displayName: "Rahma Owner",
        locale: "en",
        defaultOrganizationId: "org-rahma",
        connections: [
            {
                organizationId: "org-rahma",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-member",
        umid: "umid_00000000000000000000000002",
        email: "hvicc.member@example.test",
        displayName: "HVICC Member",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-admin",
        umid: "umid_00000000000000000000000003",
        email: "hvicc.admin@example.test",
        displayName: "HVICC Admin",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person", "organization_admin"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-communications-admin",
        umid: "umid_00000000000000000000000013",
        email: "hvicc.communications@example.test",
        displayName: "HVICC Communications Admin",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-events-admin",
        umid: "umid_00000000000000000000000014",
        email: "hvicc.events@example.test",
        displayName: "HVICC Events Admin",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-check-in-staff",
        umid: "umid_00000000000000000000000021",
        email: "hvicc.checkin@example.test",
        displayName: "HVICC Check-In Staff",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-finance-admin",
        umid: "umid_00000000000000000000000015",
        email: "hvicc.finance@example.test",
        displayName: "HVICC Finance Admin",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-spaces-admin",
        umid: "umid_00000000000000000000000016",
        email: "hvicc.spaces@example.test",
        displayName: "HVICC Spaces Admin",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-hvicc-volunteer-coordinator",
        umid: "umid_00000000000000000000000017",
        email: "hvicc.volunteers@example.test",
        displayName: "HVICC Volunteer Coordinator",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-rahma-admin",
        umid: "umid_00000000000000000000000004",
        email: "rahma.admin@example.test",
        displayName: "Rahma Admin",
        locale: "ar",
        defaultOrganizationId: "org-rahma",
        connections: [
            {
                organizationId: "org-rahma",
                roles: ["connected_person", "organization_admin"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-multi-connected",
        umid: "umid_00000000000000000000000005",
        email: "multi.connected@example.test",
        displayName: "Multi Connected Person",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
            {
                organizationId: "org-rahma",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-multi-role-admin",
        umid: "umid_00000000000000000000000018",
        email: "multi.role@example.test",
        displayName: "Multi Role Person",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
            {
                organizationId: "org-rahma",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-legacy-admin-no-assignment",
        umid: "umid_00000000000000000000000019",
        email: "legacy.admin@example.test",
        displayName: "Legacy Admin Without Assignment",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person", "organization_admin"],
                status: "active",
            },
        ],
    },
    {
        uid: "dev-pending-connection",
        umid: "umid_00000000000000000000000006",
        email: "pending.connection@example.test",
        displayName: "Pending Connection",
        locale: "en",
        connections: [
            {
                organizationId: "org-rahma",
                roles: [],
                status: "pending",
            },
        ],
    },
    {
        uid: "dev-suspended-connection",
        umid: "umid_00000000000000000000000007",
        email: "suspended.connection@example.test",
        displayName: "Suspended Connection",
        locale: "en",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "suspended",
            },
        ],
    },
    {
        uid: "dev-disconnected-connection",
        umid: "umid_00000000000000000000000008",
        email: "disconnected.connection@example.test",
        displayName: "Disconnected Connection",
        locale: "en",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: [],
                status: "disconnected",
            },
        ],
    },
    {
        uid: "dev-rejected-connection",
        umid: "umid_00000000000000000000000009",
        email: "rejected.connection@example.test",
        displayName: "Rejected Connection",
        locale: "en",
        connections: [
            {
                organizationId: "org-rahma",
                roles: [],
                status: "rejected",
            },
        ],
    },
    {
        uid: "dev-platform-super-admin",
        umid: "umid_00000000000000000000000020",
        email: "ahmed@cloudpixel.com",
        displayName: "Ahmed CloudPixel",
        locale: "en",
        defaultOrganizationId: "org-hvicc",
        platformRole: "platform_super_admin",
        connections: [
            {
                organizationId: "org-hvicc",
                roles: ["connected_person"],
                status: "active",
            },
        ],
    },
];
export const seedOrganizationConnectionRecords = seedPeople.flatMap((person) => person.connections.map((connection) => buildBasicOrganizationConnectionRecord({
    organizationId: connection.organizationId,
    personId: person.uid,
    roles: connection.roles,
    source: "development_seed",
    status: connection.status,
    timestamp: "development-seed",
    umidSnapshot: person.umid,
})));
export const seedOrganizationConnectionProjections = seedOrganizationConnectionRecords.map(buildOrganizationConnectionProjection);
export const seedOrganizationRoleAssignments = [
    buildOrganizationRoleAssignment({
        assignedBy: "system:development-seed",
        organizationId: "org-hvicc",
        personId: "dev-platform-super-admin",
        roleIds: ["organizationOwner"],
        source: "system_bootstrap",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "system:development-seed",
        organizationId: "org-rahma",
        personId: "dev-rahma-owner",
        roleIds: ["organizationOwner"],
        source: "system_bootstrap",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "migration:hvicc",
        migration: {
            legacyAdminFlag: true,
            legacyFirebaseUid: "dev-hvicc-admin",
            legacySource: "hvicc_flutterflow_users",
            migratedAt: "development-seed",
        },
        organizationId: "org-hvicc",
        personId: "dev-hvicc-admin",
        roleIds: ["organizationAdmin"],
        source: "migration_hvicc",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "system:development-seed",
        organizationId: "org-rahma",
        personId: "dev-rahma-admin",
        roleIds: ["organizationAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-communications-admin",
        roleIds: ["communicationsAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-events-admin",
        roleIds: ["eventsAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-check-in-staff",
        roleIds: ["eventCheckInStaff"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-finance-admin",
        roleIds: ["financeAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-spaces-admin",
        roleIds: ["spacesAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-volunteer-coordinator",
        roleIds: ["volunteerCoordinator"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-multi-role-admin",
        roleIds: ["communicationsAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-rahma-owner",
        organizationId: "org-rahma",
        personId: "dev-multi-role-admin",
        roleIds: ["eventsAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
    buildOrganizationRoleAssignment({
        assignedBy: "dev-platform-super-admin",
        organizationId: "org-hvicc",
        personId: "dev-suspended-connection",
        roleIds: ["organizationAdmin"],
        source: "development_seed",
        timestamp: "development-seed",
    }),
];
export const seedOrganizationRoleAssignmentEvents = seedOrganizationRoleAssignments.map((assignment) => buildOrganizationRoleAssignmentAuditEvent({
    action: "assigned",
    actorPersonId: assignment.assignedBy,
    eventId: `${assignment.personId}_assigned_${assignment.roleIds.join("_")}`,
    organizationId: assignment.organizationId,
    roleIds: assignment.roleIds,
    source: assignment.source,
    targetPersonId: assignment.personId,
    timestamp: "development-seed",
}));
export const seedConnectionInvitations = [
    {
        createdAt: "development-seed",
        expiresAt: "2099-01-01T00:00:00.000Z",
        intendedEmailNormalized: null,
        invitationId: "rahma-test-invite",
        maxUses: 1,
        organizationId: "org-rahma",
        revokedAt: null,
        status: "active",
        tokenHash: "547223ebac9cd6d6dab307ec91ea05bc0a1c3da175afca3a7e10d1650bb583e1",
        uses: 0,
    },
];
export const demoRealtimeRecords = {
    "org-hvicc": {
        organizationId: "org-hvicc",
        message: "HVICC development status is live.",
        updatedBy: "seed",
        version: 1,
    },
    "org-rahma": {
        organizationId: "org-rahma",
        message: "Rahma development status is live.",
        updatedBy: "seed",
        version: 1,
    },
};
export const demoCommunityEvents = [
    {
        allDay: false,
        archivedAt: null,
        campusId: "campus-hvicc-main",
        campusNameSnapshot: "HVICC Main Campus",
        createdAt: "development-seed",
        createdBy: "development-seed",
        description: "Meet the HVICC team, preview Shdeed's community workflow, and share what would help your household most as the platform grows.",
        descriptionAr: "تعرّف على فريق HVICC وشاهد مسار شديد المجتمعي وشارك بما يساعد أسرتك أكثر مع تطور المنصة.",
        endsAt: "2026-09-06T00:00:00.000Z",
        eventId: "first-community-night",
        id: "first-community-night",
        image: {
            altText: "Community members gathering in the HVICC main hall",
            altTextAr: "أفراد المجتمع يجتمعون في قاعة HVICC الرئيسية",
            storagePath: "organizations/org-hvicc/events/first-community-night/community-night.jpg",
        },
        locationName: "HVICC Main Hall",
        registrationEnabled: true,
        registrationOpensAt: "2026-08-08T16:00:00.000Z",
        registrationClosesAt: "2026-09-05T21:30:00.000Z",
        registrationCapacity: 75,
        registrationConfirmedCount: 0,
        registrationCancellationAllowed: true,
        attendanceCheckedInCount: 0,
        notificationIntentId: "event-first-community-night",
        notificationIntentStatus: "requested",
        notificationRequestedOnPublish: true,
        organizationId: "org-hvicc",
        publishedAt: "2026-08-08T16:00:00.000Z",
        source: "experience_twenty_three",
        startsAt: "2026-09-05T22:30:00.000Z",
        status: "published",
        title: "Community Welcome Night",
        titleAr: "ليلة الترحيب المجتمعية",
        summary: "Meet the team, see Shdeed's first community workflow, and share what would help your household most.",
        summaryAr: "تعرف على الفريق وشاهد أول مسار مجتمعي في شديد وشارك بما يساعد أسرتك أكثر.",
        timezone: "America/New_York",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        visibility: "connected",
    },
    {
        allDay: false,
        archivedAt: null,
        campusId: "campus-rahma-main",
        campusNameSnapshot: "Rahma Main Campus",
        createdAt: "development-seed",
        createdBy: "development-seed",
        description: "A short orientation for families and volunteers preparing Rahma's first Shdeed-powered service day, including program overview and volunteer next steps.",
        descriptionAr: "تعريف قصير للعائلات والمتطوعين استعداداً لأول يوم خدمة في رحمة عبر شديد، مع نظرة على البرنامج والخطوات التالية للمتطوعين.",
        endsAt: "2026-09-12T21:30:00.000Z",
        eventId: "family-service-orientation",
        id: "family-service-orientation",
        image: {
            altText: "Rahma families and volunteers in the community room",
            altTextAr: "عائلات ومتطوعو رحمة في غرفة المجتمع",
            storagePath: "organizations/org-rahma/events/family-service-orientation/service-orientation.jpg",
        },
        locationName: "Rahma Community Room",
        registrationEnabled: true,
        registrationOpensAt: "2026-08-08T16:00:00.000Z",
        registrationClosesAt: "2026-09-12T19:00:00.000Z",
        registrationCapacity: 40,
        registrationConfirmedCount: 0,
        registrationCancellationAllowed: true,
        attendanceCheckedInCount: 0,
        notificationIntentId: null,
        notificationIntentStatus: "none",
        notificationRequestedOnPublish: false,
        organizationId: "org-rahma",
        publishedAt: "2026-08-08T16:00:00.000Z",
        source: "experience_twenty_three",
        startsAt: "2026-09-12T20:00:00.000Z",
        status: "published",
        title: "Family Service Orientation",
        titleAr: "تعريف بخدمات العائلة",
        summary: "A short orientation for families and volunteers preparing Rahma's first Shdeed-powered service day.",
        summaryAr: "تعريف قصير للعائلات والمتطوعين استعداداً لأول يوم خدمة في رحمة عبر شديد.",
        timezone: "America/New_York",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        visibility: "connected",
    },
];
export const demoDonationIntents = [
    {
        id: "first-hvicc-donation",
        organizationId: "org-hvicc",
        donorUid: "dev-hvicc-member",
        amountCents: 5000,
        currency: "usd",
        designation: "general",
        status: "succeeded",
        provider: "mock_stripe",
        providerEventId: "mock_evt_seed_hvicc_first_donation",
        source: "experience_three",
    },
    {
        id: "first-rahma-donation",
        organizationId: "org-rahma",
        donorUid: "dev-rahma-admin",
        amountCents: 2500,
        currency: "usd",
        designation: "general",
        status: "succeeded",
        provider: "mock_stripe",
        providerEventId: "mock_evt_seed_rahma_first_donation",
        source: "experience_three",
    },
];
export const demoDonationLedgerEntries = demoDonationIntents.map((intent) => ({
    id: intent.id,
    organizationId: intent.organizationId,
    donationIntentId: intent.id,
    donorUid: intent.donorUid,
    amountCents: intent.amountCents,
    currency: intent.currency,
    designation: intent.designation,
    provider: intent.provider,
    providerEventId: intent.providerEventId,
    source: intent.source,
    status: "posted",
}));
export const demoGivingFunds = [
    {
        aggregateUpdatedAt: "development-seed",
        confirmedAmountMinor: 0,
        confirmedDonationCount: 0,
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        description: "Support the general operations and community services at HVICC.",
        descriptionAr: "ادعم التشغيل العام وخدمات المجتمع في مركز HVICC.",
        designation: "general",
        displayOrder: 10,
        fundId: "general",
        id: "general",
        image: {
            altText: "HVICC general giving",
            altTextAr: "العطاء العام في HVICC",
            storagePath: null,
        },
        name: "General Giving",
        nameAr: "العطاء العام",
        organizationId: "org-hvicc",
        source: "experience_twenty_eight",
        status: "active",
        type: "general",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
        visibility: "connected",
    },
    {
        aggregateUpdatedAt: "development-seed",
        confirmedAmountMinor: 5_000,
        confirmedDonationCount: 1,
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        description: "Designated Zakat giving for eligible community assistance.",
        descriptionAr: "تبرعات الزكاة المخصصة للمساعدة المجتمعية المؤهلة.",
        designation: "zakat",
        displayOrder: 20,
        fundId: "zakat",
        id: "zakat",
        image: {
            altText: "HVICC Zakat fund",
            altTextAr: "صندوق الزكاة في HVICC",
            storagePath: null,
        },
        name: "Zakat Fund",
        nameAr: "صندوق الزكاة",
        organizationId: "org-hvicc",
        source: "experience_twenty_eight",
        status: "active",
        type: "zakat",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
        visibility: "connected",
    },
    {
        aggregateUpdatedAt: null,
        confirmedAmountMinor: 0,
        confirmedDonationCount: 0,
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        description: "General sadaqah and charity giving for community needs.",
        descriptionAr: "صدقة عامة وعطاء خيري لاحتياجات المجتمع.",
        designation: "sadaqah",
        displayOrder: 30,
        fundId: "sadaqah",
        id: "sadaqah",
        image: {
            altText: "HVICC Sadaqah fund",
            altTextAr: "صندوق الصدقة في HVICC",
            storagePath: null,
        },
        name: "Sadaqah Fund",
        nameAr: "صندوق الصدقة",
        organizationId: "org-hvicc",
        source: "experience_twenty_eight",
        status: "active",
        type: "sadaqah",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
        visibility: "connected",
    },
    {
        aggregateUpdatedAt: null,
        confirmedAmountMinor: 0,
        confirmedDonationCount: 0,
        createdAt: "development-seed",
        createdBy: "dev-rahma-admin",
        description: "Support Rahma Center programs and community operations.",
        descriptionAr: "ادعم برامج مركز الرحمة وتشغيل المجتمع.",
        designation: "general",
        displayOrder: 10,
        fundId: "general",
        id: "general",
        image: {
            altText: "Rahma general giving",
            altTextAr: "العطاء العام في الرحمة",
            storagePath: null,
        },
        name: "General Giving",
        nameAr: "العطاء العام",
        organizationId: "org-rahma",
        source: "experience_twenty_eight",
        status: "active",
        type: "general",
        updatedAt: "development-seed",
        updatedBy: "dev-rahma-admin",
        visibility: "connected",
    },
];
export const demoCampaigns = [
    {
        aggregateUpdatedAt: "development-seed",
        archivedAt: null,
        campaignId: "winter-relief",
        completedAt: null,
        confirmedAmountMinor: 5_000,
        confirmedDonationCount: 1,
        createdAt: "development-seed",
        createdBy: "dev-hvicc-admin",
        currency: "usd",
        description: "Help HVICC provide winter relief support to local families.",
        descriptionAr: "ساعد HVICC في تقديم دعم الإغاثة الشتوية للأسر المحلية.",
        displayOrder: 10,
        endsAt: "2027-02-01T05:00:00.000Z",
        fundId: "zakat",
        goalAmountMinor: 5_000_000,
        id: "winter-relief",
        image: {
            altText: "Winter relief campaign",
            altTextAr: "حملة الإغاثة الشتوية",
            storagePath: null,
        },
        organizationId: "org-hvicc",
        publishedAt: "development-seed",
        source: "experience_twenty_eight",
        startsAt: "2026-08-01T04:00:00.000Z",
        status: "published",
        title: "Winter Relief",
        titleAr: "إغاثة الشتاء",
        updatedAt: "development-seed",
        updatedBy: "dev-hvicc-admin",
        visibility: "connected",
    },
    {
        aggregateUpdatedAt: null,
        archivedAt: null,
        campaignId: "community-pantry",
        completedAt: null,
        confirmedAmountMinor: 0,
        confirmedDonationCount: 0,
        createdAt: "development-seed",
        createdBy: "dev-rahma-admin",
        currency: "usd",
        description: "Stock the Rahma pantry for neighbors who need weekly support.",
        descriptionAr: "دعم مخزن الرحمة للجيران الذين يحتاجون إلى مساعدة أسبوعية.",
        displayOrder: 10,
        endsAt: null,
        fundId: "general",
        goalAmountMinor: null,
        id: "community-pantry",
        image: {
            altText: "Community pantry campaign",
            altTextAr: "حملة مخزن المجتمع",
            storagePath: null,
        },
        organizationId: "org-rahma",
        publishedAt: "development-seed",
        source: "experience_twenty_eight",
        startsAt: null,
        status: "published",
        title: "Community Pantry",
        titleAr: "مخزن المجتمع",
        updatedAt: "development-seed",
        updatedBy: "dev-rahma-admin",
        visibility: "connected",
    },
];
export const demoDonationTransactions = [
    {
        id: "txn_seed_hvicc_first_donation",
        transactionId: "txn_seed_hvicc_first_donation",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-member",
        donorDisplayNameSnapshot: "HVICC Member",
        destinationType: "campaign",
        fundId: "zakat",
        fundTypeSnapshot: "zakat",
        fundNameSnapshot: "Zakat Fund",
        fundNameArSnapshot: "صندوق الزكاة",
        campaignId: "winter-relief",
        campaignTitleSnapshot: "Winter Relief",
        campaignTitleArSnapshot: "إغاثة الشتاء",
        transactionType: "donation",
        status: "confirmed",
        amountMinor: 5000,
        grossAmountMinor: 5000,
        platformFeeMinor: 0,
        organizationNetMinor: 5000,
        currency: "usd",
        provider: "stripe",
        providerConnectedAccountId: "acct_test_hvicc_standard",
        providerPaymentIntentId: "pi_test_seed_hvicc_first_donation",
        providerChargeId: "ch_test_seed_hvicc_first_donation",
        providerStatus: "succeeded",
        idempotencyKeyHash: "seed-hvicc-first-donation",
        receiptId: "rcpt_seed_hvicc_first_donation",
        refundedAmountMinor: 0,
        refundPendingAmountMinor: 0,
        refundStatus: "none",
        remainingRefundableAmountMinor: 5000,
        source: "experience_twenty_seven",
        createdAt: "development-seed",
        updatedAt: "development-seed",
        confirmedAt: "development-seed",
        failedAt: null,
        cancelledAt: null,
    },
    {
        id: "txn_seed_rahma_first_donation",
        transactionId: "txn_seed_rahma_first_donation",
        organizationId: "org-rahma",
        personId: "dev-rahma-admin",
        donorDisplayNameSnapshot: "Rahma Admin",
        destinationType: "general",
        fundId: null,
        fundTypeSnapshot: null,
        fundNameSnapshot: null,
        fundNameArSnapshot: null,
        campaignId: null,
        campaignTitleSnapshot: null,
        campaignTitleArSnapshot: null,
        transactionType: "donation",
        status: "confirmed",
        amountMinor: 2500,
        grossAmountMinor: 2500,
        platformFeeMinor: 0,
        organizationNetMinor: 2500,
        currency: "usd",
        provider: "stripe",
        providerConnectedAccountId: "acct_test_rahma_standard",
        providerPaymentIntentId: "pi_test_seed_rahma_first_donation",
        providerChargeId: "ch_test_seed_rahma_first_donation",
        providerStatus: "succeeded",
        idempotencyKeyHash: "seed-rahma-first-donation",
        receiptId: "rcpt_seed_rahma_first_donation",
        refundedAmountMinor: 0,
        refundPendingAmountMinor: 0,
        refundStatus: "none",
        remainingRefundableAmountMinor: 2500,
        source: "experience_twenty_seven",
        createdAt: "development-seed",
        updatedAt: "development-seed",
        confirmedAt: "development-seed",
        failedAt: null,
        cancelledAt: null,
    },
];
export const demoFinancialLedgerEntries = demoDonationTransactions.map((transaction) => ({
    id: `${transaction.transactionId}_organization_net`,
    amountMinor: transaction.organizationNetMinor,
    createdAt: transaction.confirmedAt,
    createdBy: "system:stripeConnectWebhook",
    currency: transaction.currency,
    direction: "credit",
    ledgerEntryId: `${transaction.transactionId}_organization_net`,
    organizationId: transaction.organizationId,
    provider: "stripe",
    providerPaymentIntentId: transaction.providerPaymentIntentId ?? "",
    source: "experience_twenty_seven",
    transactionId: transaction.transactionId,
    type: "donation_organization_net",
}));
export const demoDonationReceipts = demoDonationTransactions.map((transaction) => ({
    id: transaction.receiptId ?? `rcpt_${transaction.transactionId}`,
    amountMinor: transaction.amountMinor,
    campaignId: transaction.campaignId,
    campaignTitleArSnapshot: transaction.campaignTitleArSnapshot,
    campaignTitleSnapshot: transaction.campaignTitleSnapshot,
    confirmedAt: transaction.confirmedAt,
    createdAt: transaction.confirmedAt,
    currency: transaction.currency,
    destinationType: transaction.destinationType,
    donorDisplayNameSnapshot: transaction.donorDisplayNameSnapshot,
    fundId: transaction.fundId,
    fundNameArSnapshot: transaction.fundNameArSnapshot,
    fundNameSnapshot: transaction.fundNameSnapshot,
    fundTypeSnapshot: transaction.fundTypeSnapshot,
    organizationId: transaction.organizationId,
    personId: transaction.personId,
    provider: "stripe",
    providerPaymentIntentId: transaction.providerPaymentIntentId ?? "",
    providerRefundId: null,
    receiptId: transaction.receiptId ?? `rcpt_${transaction.transactionId}`,
    receiptNumber: transaction.organizationId === "org-hvicc" ? "SHD-SEED-HVICC" : "SHD-SEED-RAHMA",
    receiptType: "donation",
    refundId: null,
    refundedAmountMinor: transaction.refundedAmountMinor,
    refundStatus: transaction.refundStatus,
    remainingAmountMinor: transaction.remainingRefundableAmountMinor,
    source: "experience_twenty_seven",
    transactionId: transaction.transactionId,
}));
export const demoDonationRefunds = [];
export const demoCommerceReconciliationRuns = [
    {
        checkedAt: "development-seed",
        checkedTransactionCount: 1,
        completedAt: "development-seed",
        createdAt: "development-seed",
        errorCode: null,
        id: "seed-hvicc-commerce-reconciliation",
        mismatchCount: 0,
        organizationId: "org-hvicc",
        requestedBy: "development-seed",
        runId: "seed-hvicc-commerce-reconciliation",
        source: "experience_twenty_nine",
        status: "matched",
        targetTransactionId: "txn_seed_hvicc_first_donation",
        updatedAt: "development-seed",
    },
];
export const demoCommerceReconciliationMismatches = [];
const emptyCommerceRequirements = emptyCommerceRequirementsSummary();
export const demoOrganizationCommerceConfigurations = [
    {
        architecture: "standard",
        capabilityStatus: {
            cardPayments: "active",
            transfers: "active",
        },
        chargesEnabled: true,
        connectedAccountId: "acct_test_hvicc_standard",
        createdAt: "development-seed",
        detailsSubmitted: true,
        id: "commerce",
        lastProviderSyncAt: "development-seed",
        onboardingCompletedAt: "development-seed",
        onboardingStartedAt: "development-seed",
        onboardingStatus: "ready",
        organizationId: "org-hvicc",
        payoutsEnabled: true,
        provider: "stripe",
        providerCountry: "US",
        providerDefaultCurrency: "usd",
        readiness: "ready",
        requirements: emptyCommerceRequirements,
        restrictedReasonCode: null,
        source: "experience_twenty_six",
        updatedAt: "development-seed",
    },
    {
        architecture: "standard",
        capabilityStatus: {
            cardPayments: "active",
            transfers: "active",
        },
        chargesEnabled: true,
        connectedAccountId: "acct_test_rahma_standard",
        createdAt: "development-seed",
        detailsSubmitted: true,
        id: "commerce",
        lastProviderSyncAt: "development-seed",
        onboardingCompletedAt: "development-seed",
        onboardingStartedAt: "development-seed",
        onboardingStatus: "ready",
        organizationId: "org-rahma",
        payoutsEnabled: true,
        provider: "stripe",
        providerCountry: "US",
        providerDefaultCurrency: "usd",
        readiness: "ready",
        requirements: emptyCommerceRequirements,
        restrictedReasonCode: null,
        source: "experience_twenty_six",
        updatedAt: "development-seed",
    },
];
export const demoCommerceConnectedAccountIndex = demoOrganizationCommerceConfigurations
    .filter((configuration) => configuration.connectedAccountId !== null)
    .map((configuration) => ({
    connectedAccountId: configuration.connectedAccountId,
    environment: "development",
    organizationId: configuration.organizationId,
    provider: "stripe",
    source: "experience_twenty_six",
    updatedAt: "development-seed",
}));
export const demoRamadanModes = [
    {
        id: "ramadan-2027",
        organizationId: "org-hvicc",
        modeId: "ramadan-2027",
        seasonYear: 2027,
        status: "active",
        title: "Ramadan Operations 2027",
        titleAr: "عمليات رمضان 2027",
        summary: "Synthetic Ramadan mode for iftar sponsorship readiness, daily slot availability, and real-time admin visibility.",
        summaryAr: "وضع رمضان التجريبي لجاهزية رعاية الإفطار وتوفر الخانات اليومية والرؤية المباشرة للإدارة.",
        sponsorshipsEnabled: true,
        slotPriceCents: 50000,
        currency: "usd",
        dayCount: 30,
        source: "experience_four",
    },
    {
        id: "ramadan-2027",
        organizationId: "org-rahma",
        modeId: "ramadan-2027",
        seasonYear: 2027,
        status: "active",
        title: "Ramadan Operations 2027",
        titleAr: "عمليات رمضان 2027",
        summary: "Synthetic Ramadan mode for Rahma's iftar sponsorship availability and development readiness.",
        summaryAr: "وضع رمضان التجريبي لتوفر رعاية الإفطار في رحمة وجاهزية التطوير.",
        sponsorshipsEnabled: true,
        slotPriceCents: 35000,
        currency: "usd",
        dayCount: 30,
        source: "experience_four",
    },
];
export const demoRamadanSetups = [
    {
        archivedAt: null,
        campusPrayerConfigs: [
            {
                campusId: "main-campus",
                prayerOverrides: [
                    {
                        displayTime: "05:45",
                        enabled: true,
                        iqamaTime: "05:45",
                        note: {
                            ar: null,
                            en: "Ramadan Fajr iqama override for the main campus.",
                        },
                        prayerId: "fajr",
                    },
                    {
                        displayTime: "19:12",
                        enabled: true,
                        iqamaTime: "19:12",
                        note: {
                            ar: null,
                            en: "Maghrib is displayed as the Iftar time.",
                        },
                        prayerId: "maghrib",
                    },
                    {
                        displayTime: "21:05",
                        enabled: true,
                        iqamaTime: "21:05",
                        note: null,
                        prayerId: "isha",
                    },
                ],
                sunrise: {
                    display: true,
                    label: {
                        ar: "الشروق",
                        en: "Sunrise",
                    },
                },
                timezone: "America/New_York",
            },
        ],
        completedAt: null,
        computed: {
            evaluatedAt: "2027-02-08T17:00:00.000Z",
            lastTenNightsActive: false,
            lastTenNightsStartsOn: "2027-02-28",
            phase: "active",
            ramadanDay: 1,
        },
        createdAt: "development-seed",
        createdBy: "development-seed",
        defaultCampusId: "main-campus",
        endAdjustmentDays: 0,
        endsOn: "2027-03-09",
        experienceOpensAt: "2027-01-25",
        featuredRamadanContentId: "ramadan-1448-message",
        hijriYear: 1448,
        home: {
            message: {
                ar: "تم اعتماد إعداد رمضان لهذا العام مع أوقات التراويح والقيام.",
                en: "Ramadan setup is approved with Taraweeh and Qiyam details ready.",
            },
            title: {
                ar: "رمضان 1448",
                en: "Ramadan 1448",
            },
        },
        id: "ramadan-1448",
        lastTenNights: {
            approvedStartsOn: null,
            enabled: true,
            homeMessage: {
                ar: "تبدأ العشر الأواخر حسب تقويم رمضان المعتمد للمؤسسة.",
                en: "The last ten nights follow the organization's approved Ramadan dates.",
            },
            homeTitle: {
                ar: "العشر الأواخر",
                en: "Last ten nights",
            },
            qiyamPriority: true,
        },
        linkedOperationalModeId: "ramadan-1448-mode",
        organizationId: "org-hvicc",
        iqamaPhases: [
            {
                endsOn: "2027-02-17",
                label: {
                    ar: "الأيام العشرة الأولى",
                    en: "First 10 days",
                },
                phaseId: "firstTen",
                prayerOverrides: [
                    {
                        displayTime: "05:45",
                        enabled: true,
                        iqamaTime: "05:45",
                        note: { ar: null, en: "First ten Fajr iqama." },
                        prayerId: "fajr",
                    },
                    {
                        displayTime: "19:12",
                        enabled: true,
                        iqamaTime: "19:12",
                        note: null,
                        prayerId: "maghrib",
                    },
                    {
                        displayTime: "21:05",
                        enabled: true,
                        iqamaTime: "21:05",
                        note: null,
                        prayerId: "isha",
                    },
                ],
                startsOn: "2027-02-08",
            },
            {
                endsOn: "2027-02-27",
                label: {
                    ar: "الأيام العشرة الثانية",
                    en: "Second 10 days",
                },
                phaseId: "secondTen",
                prayerOverrides: [
                    {
                        displayTime: "05:40",
                        enabled: true,
                        iqamaTime: "05:40",
                        note: null,
                        prayerId: "fajr",
                    },
                    {
                        displayTime: "19:20",
                        enabled: true,
                        iqamaTime: "19:20",
                        note: null,
                        prayerId: "maghrib",
                    },
                    {
                        displayTime: "21:10",
                        enabled: true,
                        iqamaTime: "21:10",
                        note: null,
                        prayerId: "isha",
                    },
                ],
                startsOn: "2027-02-18",
            },
            {
                endsOn: "2027-03-09",
                label: {
                    ar: "العشر الأواخر",
                    en: "Last 10 days",
                },
                phaseId: "lastTen",
                prayerOverrides: [
                    {
                        displayTime: "05:35",
                        enabled: true,
                        iqamaTime: "05:35",
                        note: null,
                        prayerId: "fajr",
                    },
                    {
                        displayTime: "19:28",
                        enabled: true,
                        iqamaTime: "19:28",
                        note: null,
                        prayerId: "maghrib",
                    },
                    {
                        displayTime: "21:15",
                        enabled: true,
                        iqamaTime: "21:15",
                        note: null,
                        prayerId: "isha",
                    },
                ],
                startsOn: "2027-02-28",
            },
        ],
        qiyam: [
            {
                campusId: "main-campus",
                enabled: true,
                endsOn: "2027-03-09",
                notes: {
                    ar: "قيام الليل في العشر الأواخر.",
                    en: "Qiyam is emphasized during the last ten nights.",
                },
                startsOn: "2027-02-28",
                startTime: "03:45",
            },
        ],
        ramadanId: "ramadan-1448",
        source: "experience_thirty_two",
        startAdjustmentDays: 0,
        startsOn: "2027-02-08",
        status: "ready",
        sponsorshipOpensAt: "2027-01-28",
        taraweeh: [
            {
                campusId: "main-campus",
                enabled: true,
                notes: {
                    ar: "تبدأ التراويح بعد صلاة العشاء.",
                    en: "Taraweeh begins shortly after Isha.",
                },
                rakahCount: 20,
                relativeToIshaMinutes: 15,
                startTime: null,
            },
        ],
        tahajjudNights: [
            {
                enabled: true,
                gregorianDate: "2027-02-28",
                nightId: "tahajjud-20270228-1",
                notes: { ar: null, en: "Tahajjud begins before Fajr." },
                startTime: "03:45",
            },
            {
                enabled: true,
                gregorianDate: "2027-03-02",
                nightId: "tahajjud-20270302-2",
                notes: null,
                startTime: "03:40",
            },
            {
                enabled: true,
                gregorianDate: "2027-03-08",
                nightId: "tahajjud-20270308-3",
                notes: null,
                startTime: "03:35",
            },
        ],
        guestImams: {
            enabled: true,
            profiles: [
                {
                    bio: {
                        ar: null,
                        en: "Leading selected Taraweeh and Tahajjud prayers during Ramadan.",
                    },
                    displayName: { ar: null, en: "Sheikh Omar Khalil" },
                    enabled: true,
                    imamId: "imam-sheikh-omar",
                    photoUrl: null,
                    sortOrder: 0,
                    title: { ar: null, en: "Guest Imam" },
                },
            ],
        },
        timezone: "America/New_York",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const demoIftarSponsorshipDefaults = [
    {
        capacityByWeekday: {
            friday: 6,
            monday: 2,
            saturday: 5,
            sunday: 2,
            thursday: 2,
            tuesday: 2,
            wednesday: 2,
        },
        configId: "defaults",
        createdAt: "development-seed",
        createdBy: "development-seed",
        currency: "usd",
        dedication: {
            allowedTypes: ["general", "inHonorOf", "inMemoryOf"],
            enabled: true,
            maxLength: 120,
            publicDisplayAllowed: false,
        },
        defaultPricePerSpotMinor: 50_000,
        fridayCapacitySpots: 6,
        id: "defaults",
        organizationId: "org-hvicc",
        programEnabled: true,
        publicNotes: {
            ar: "هذه معاينة لتكوين الرعاية فقط؛ يبدأ الحجز والدفع لاحقاً.",
            en: "Configuration preview only; sponsorship reservations and payment open later.",
        },
        ramadanId: "ramadan-1448",
        recognition: {
            anonymousPublicRecognitionAllowed: true,
            publicRecognitionAllowed: true,
            sponsorDisplayNameAllowed: true,
        },
        saturdayCapacitySpots: 5,
        source: "experience_thirty_three",
        sponsorshipClosesDayOffset: -1,
        sponsorshipClosesLocalTime: "17:00",
        sponsorshipOpensAt: null,
        standardCapacitySpots: 2,
        updatedAt: "development-seed",
        updatedBy: "development-seed",
    },
];
export const demoIftarSponsorshipDays = buildRamadanIftarDaysFromDefaults({
    actorUid: "development-seed",
    defaults: demoIftarSponsorshipDefaults[0],
    setup: demoRamadanSetups[0],
    timestamp: "development-seed",
}).map((day, index) => ({
    ...day,
    id: day.iftarDayId,
    status: index < 3 ? "open" : day.status,
}));
export const demoIftarSponsorshipSlots = [
    {
        id: "ramadan-2027-day-01",
        organizationId: "org-hvicc",
        modeId: "ramadan-2027",
        dayNumber: 1,
        label: "Ramadan day 1 iftar",
        labelAr: "إفطار اليوم الأول من رمضان",
        amountCents: 50000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
    {
        id: "ramadan-2027-day-02",
        organizationId: "org-hvicc",
        modeId: "ramadan-2027",
        dayNumber: 2,
        label: "Ramadan day 2 iftar",
        labelAr: "إفطار اليوم الثاني من رمضان",
        amountCents: 50000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
    {
        id: "ramadan-2027-day-03",
        organizationId: "org-hvicc",
        modeId: "ramadan-2027",
        dayNumber: 3,
        label: "Ramadan day 3 iftar",
        labelAr: "إفطار اليوم الثالث من رمضان",
        amountCents: 50000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
    {
        id: "ramadan-2027-day-01",
        organizationId: "org-rahma",
        modeId: "ramadan-2027",
        dayNumber: 1,
        label: "Ramadan day 1 iftar",
        labelAr: "إفطار اليوم الأول من رمضان",
        amountCents: 35000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
    {
        id: "ramadan-2027-day-02",
        organizationId: "org-rahma",
        modeId: "ramadan-2027",
        dayNumber: 2,
        label: "Ramadan day 2 iftar",
        labelAr: "إفطار اليوم الثاني من رمضان",
        amountCents: 35000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
    {
        id: "ramadan-2027-day-03",
        organizationId: "org-rahma",
        modeId: "ramadan-2027",
        dayNumber: 3,
        label: "Ramadan day 3 iftar",
        labelAr: "إفطار اليوم الثالث من رمضان",
        amountCents: 35000,
        currency: "usd",
        status: "available",
        source: "experience_four",
    },
];
export const demoSpaces = [
    {
        id: "main-hall",
        spaceId: "main-hall",
        organizationId: "org-hvicc",
        campusId: "campus-hvicc-main",
        type: "eventHall",
        name: "Main Hall",
        nameAr: "القاعة الرئيسية",
        description: "A synthetic reservable hall for community programs, family gatherings, and development workflow testing.",
        descriptionAr: "قاعة تجريبية قابلة للحجز للبرامج المجتمعية والمناسبات العائلية واختبار سير العمل.",
        locationName: "HVICC Main Building",
        capacity: 180,
        amenities: ["tables", "chairs", "projector", "audioSystem", "stage", "wifi"],
        accessibility: {
            features: ["wheelchairAccessible", "accessibleEntrance", "accessibleRestroom"],
            notes: {
                ar: "مدخل ودورات مياه مهيأة في المبنى الرئيسي.",
                en: "Accessible entrance and restrooms in the main building.",
            },
        },
        primaryImage: {
            altText: {
                ar: "القاعة الرئيسية في مركز HVICC",
                en: "HVICC main hall",
            },
            sortOrder: 0,
            storagePath: "organizations/org-hvicc/spaces/main-hall/primary.jpg",
            visibility: "inherit",
        },
        galleryImages: [],
        timezone: "America/New_York",
        operatingHours: defaultSpaceOperatingHours(),
        hourlyPriceCents: 7500,
        currency: "usd",
        pricing: {
            activeAgreementId: "hvicc-space-rental-v1",
            agreementRequired: true,
            baseRateMinor: 7500,
            currency: "usd",
            depositMinor: 10000,
            effectiveFrom: "development-seed",
            fixedFees: [
                {
                    amountMinor: 2500,
                    feeId: "cleaning",
                    label: {
                        ar: "رسوم التنظيف",
                        en: "Cleaning fee",
                    },
                },
            ],
            minimumChargeMinor: 15000,
            pricingEnabled: true,
            pricingType: "hourly",
            pricingVersion: 1,
            rateUnit: "hour",
            source: "experience_forty_one",
            updatedAt: "development-seed",
            updatedBy: "development-seed",
        },
        status: "active",
        visibility: "connected",
        source: "experience_thirty_nine",
    },
    {
        id: "community-room",
        spaceId: "community-room",
        organizationId: "org-rahma",
        campusId: "campus-rahma-main",
        type: "multipurposeRoom",
        name: "Community Room",
        nameAr: "غرفة المجتمع",
        description: "A synthetic reservable room for classes, volunteer orientations, and family service meetings.",
        descriptionAr: "غرفة تجريبية قابلة للحجز للدروس وتعريف المتطوعين واجتماعات خدمة العائلات.",
        locationName: "Rahma Community Center",
        capacity: 64,
        amenities: ["tables", "chairs", "projector", "wifi"],
        accessibility: {
            features: ["wheelchairAccessible", "accessibleEntrance"],
            notes: {
                ar: "غرفة في الطابق الأرضي مع مدخل مهيأ.",
                en: "Ground-floor room with accessible entry.",
            },
        },
        primaryImage: {
            altText: {
                ar: "غرفة المجتمع في مركز رحمة",
                en: "Rahma community room",
            },
            sortOrder: 0,
            storagePath: "organizations/org-rahma/spaces/community-room/primary.jpg",
            visibility: "inherit",
        },
        galleryImages: [],
        timezone: "America/New_York",
        operatingHours: defaultSpaceOperatingHours(),
        hourlyPriceCents: 4500,
        currency: "usd",
        pricing: {
            activeAgreementId: null,
            agreementRequired: false,
            baseRateMinor: 12000,
            currency: "usd",
            depositMinor: 0,
            effectiveFrom: "development-seed",
            fixedFees: [],
            minimumChargeMinor: 12000,
            pricingEnabled: true,
            pricingType: "flat",
            pricingVersion: 1,
            rateUnit: "reservation",
            source: "experience_forty_one",
            updatedAt: "development-seed",
            updatedBy: "development-seed",
        },
        status: "active",
        visibility: "connected",
        source: "experience_thirty_nine",
    },
];
export const demoVolunteerOpportunities = [
    {
        id: "family-night-welcome",
        opportunityId: "family-night-welcome",
        organizationId: "org-hvicc",
        status: "published",
        visibility: "connected",
        title: "Family Night Welcome Team",
        titleAr: "فريق استقبال ليلة العائلة",
        description: "Help greet families, guide check-in, and keep the lobby calm during HVICC's first family night.",
        descriptionAr: "ساعد في استقبال العائلات وتوجيه التسجيل والحفاظ على هدوء المدخل خلال أول ليلة عائلية في HVICC.",
        instructions: "Arrive 20 minutes early, wear comfortable shoes, and check in with the volunteer coordinator.",
        instructionsAr: "احضر قبل الموعد بعشرين دقيقة، وارتد حذاءً مريحاً، وتواصل مع منسق المتطوعين.",
        campusId: "campus-hvicc-main",
        locationName: "HVICC Main Lobby",
        category: "hospitality",
        requirements: {
            agePolicy: "Youth 14+ may serve with an adult team lead.",
            physicalNotes: "Standing and light walking during the shift.",
            dressCode: "Modest, comfortable clothing.",
            trainingRequired: false,
        },
        image: {
            altText: "HVICC volunteers welcoming families at the front desk",
            altTextAr: "متطوعو HVICC يستقبلون العائلات عند مكتب الاستقبال",
            storagePath: "organizations/org-hvicc/volunteerOpportunities/family-night-welcome/hero.jpg",
        },
        startsAt: "2026-09-04T21:30:00.000Z",
        endsAt: "2026-09-05T00:30:00.000Z",
        publishedAt: "2026-08-09T12:00:00.000Z",
        completedAt: null,
        archivedAt: null,
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_forty_two",
    },
    {
        id: "service-day-support",
        opportunityId: "service-day-support",
        organizationId: "org-rahma",
        status: "published",
        visibility: "connected",
        title: "Service Day Support",
        titleAr: "دعم يوم الخدمة",
        description: "Support Rahma's family service day with setup, meal distribution, and cleanup coordination.",
        descriptionAr: "ادعم يوم خدمة العائلة في رحمة بالتجهيز وتوزيع الوجبات وتنسيق التنظيف.",
        instructions: "Meet in the community room and follow the posted shift lead assignment.",
        instructionsAr: "اجتمع في غرفة المجتمع واتبع تكليف قائد الوردية المعلن.",
        campusId: "campus-rahma-main",
        locationName: "Rahma Community Room",
        category: "service",
        requirements: {
            agePolicy: "Family-friendly opportunity; minors serve with a guardian.",
            physicalNotes: "Light lifting may be needed during setup.",
            dressCode: "Comfortable clothing suitable for setup work.",
            trainingRequired: false,
        },
        image: {
            altText: "Rahma volunteers preparing a family service table",
            altTextAr: "متطوعو رحمة يجهزون طاولة خدمة عائلية",
            storagePath: "organizations/org-rahma/volunteerOpportunities/service-day-support/hero.jpg",
        },
        startsAt: "2026-09-12T16:00:00.000Z",
        endsAt: "2026-09-12T22:00:00.000Z",
        publishedAt: "2026-08-09T12:00:00.000Z",
        completedAt: null,
        archivedAt: null,
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_forty_two",
    },
];
export const demoVolunteerShifts = [
    {
        id: "family-night-welcome-2026-09-04-setup",
        shiftId: "family-night-welcome-2026-09-04-setup",
        organizationId: "org-hvicc",
        opportunityId: "family-night-welcome",
        startsAt: "2026-09-04T21:30:00.000Z",
        endsAt: "2026-09-05T00:30:00.000Z",
        timezone: "America/New_York",
        capacity: 4,
        confirmedCount: 1,
        status: "open",
        notes: "Welcome desk and lobby support before the program begins.",
        notesAr: "دعم مكتب الاستقبال والمدخل قبل بدء البرنامج.",
        instructions: "Check in at the welcome desk and collect a volunteer badge.",
        instructionsAr: "سجّل حضورك عند مكتب الاستقبال واستلم شارة المتطوع.",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_forty_two",
    },
    {
        id: "service-day-support-2026-09-12-setup",
        shiftId: "service-day-support-2026-09-12-setup",
        organizationId: "org-rahma",
        opportunityId: "service-day-support",
        startsAt: "2026-09-12T16:00:00.000Z",
        endsAt: "2026-09-12T19:00:00.000Z",
        timezone: "America/New_York",
        capacity: 8,
        confirmedCount: 0,
        status: "open",
        notes: "Setup team for tables, supply stations, and family check-in.",
        notesAr: "فريق التجهيز للطاولات ومحطات المستلزمات وتسجيل العائلات.",
        instructions: "Ask for the service day shift lead when you arrive.",
        instructionsAr: "اسأل عن قائد وردية يوم الخدمة عند وصولك.",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_forty_two",
    },
];
export const demoVolunteerSignups = [
    {
        id: "family-night-welcome-2026-09-04-setup_dev-hvicc-member",
        signupId: "dev-hvicc-member",
        organizationId: "org-hvicc",
        opportunityId: "family-night-welcome",
        shiftId: "family-night-welcome-2026-09-04-setup",
        personId: "dev-hvicc-member",
        status: "confirmed",
        signedUpAt: "2026-08-09T12:15:00.000Z",
        cancelledAt: null,
        cancelledBy: null,
        cancellationActorType: null,
        opportunityTitleSnapshot: "Family Night Welcome Team",
        shiftStartsAt: "2026-09-04T21:30:00.000Z",
        shiftEndsAt: "2026-09-05T00:30:00.000Z",
        updatedAt: "2026-08-09T12:15:00.000Z",
        source: "experience_forty_two",
    },
];
export const demoVolunteerAttendances = [
    {
        adjustmentMinutes: 0,
        adjustmentReason: null,
        attendanceId: "dev-hvicc-member",
        checkedInAt: "2026-09-04T21:28:00.000Z",
        checkedInBy: "dev-hvicc-member",
        checkedOutAt: "2026-09-05T00:24:00.000Z",
        checkedOutBy: "dev-hvicc-member",
        checkInMethod: "self",
        checkOutMethod: "self",
        createdAt: "2026-09-04T21:28:00.000Z",
        createdBy: "dev-hvicc-member",
        id: "dev-hvicc-member",
        opportunityId: "family-night-welcome",
        opportunityTitleSnapshot: "Family Night Welcome Team",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-member",
        provisionalMinutes: 176,
        shiftEndsAt: "2026-09-05T00:30:00.000Z",
        shiftId: "family-night-welcome-2026-09-04-setup",
        shiftStartsAt: "2026-09-04T21:30:00.000Z",
        signupId: "dev-hvicc-member",
        source: "experience_forty_three",
        status: "verified",
        updatedAt: "2026-09-05T00:24:00.000Z",
        updatedBy: "dev-hvicc-member",
        verifiedAt: "2026-09-05T00:24:00.000Z",
        verifiedBy: "dev-hvicc-member",
        verifiedMinutes: 176,
    },
];
export const demoVolunteerHistoryEntries = demoVolunteerAttendances.map((attendance) => ({
    attendanceId: attendance.attendanceId,
    checkedInAt: attendance.checkedInAt,
    checkedOutAt: attendance.checkedOutAt,
    historyEntryId: `${attendance.opportunityId}_${attendance.shiftId}`.replace(/[^A-Za-z0-9_-]/g, "-"),
    id: `${attendance.opportunityId}_${attendance.shiftId}`.replace(/[^A-Za-z0-9_-]/g, "-"),
    opportunityId: attendance.opportunityId,
    opportunityTitleSnapshot: attendance.opportunityTitleSnapshot,
    organizationId: attendance.organizationId,
    personId: attendance.personId,
    shiftEndsAt: attendance.shiftEndsAt,
    shiftId: attendance.shiftId,
    shiftStartsAt: attendance.shiftStartsAt,
    source: "experience_forty_three",
    status: attendance.status,
    updatedAt: attendance.updatedAt,
    verifiedMinutes: attendance.verifiedMinutes,
}));
export const demoVolunteerServiceSummaries = [
    {
        id: "dev-hvicc-member",
        lastVerifiedAt: "2026-09-05T00:24:00.000Z",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-member",
        source: "experience_forty_three",
        summaryId: "dev-hvicc-member",
        totalVerifiedMinutes: 176,
        updatedAt: "2026-09-05T00:24:00.000Z",
        verifiedAttendanceCount: 1,
    },
];
export const demoVolunteerRecognitionAwards = [
    {
        awardedAt: "2026-09-05T00:24:00.000Z",
        awardId: "first-service",
        id: "first-service",
        label: "First volunteer service",
        labelAr: "أول خدمة تطوعية",
        organizationId: "org-hvicc",
        personId: "dev-hvicc-member",
        source: "experience_forty_three",
        thresholdMinutes: 1,
        verifiedMinutesAtAward: 176,
    },
];
export const demoSpaceAgreements = [
    {
        agreementId: "hvicc-space-rental-v1",
        body: {
            ar: "أوافق على استخدام القاعة للفترة المعتمدة فقط، واتباع تعليمات المركز، وترك المساحة نظيفة بعد الاستخدام.",
            en: "I agree to use the hall only for the approved time, follow center instructions, and leave the space clean after use.",
        },
        bodyHash: "hvicc-main-hall-agreement-v1",
        createdAt: "development-seed",
        createdBy: "development-seed",
        effectiveAt: "development-seed",
        id: "hvicc-space-rental-v1",
        organizationId: "org-hvicc",
        source: "experience_forty_one",
        spaceId: "main-hall",
        status: "active",
        title: {
            ar: "اتفاقية استخدام القاعة الرئيسية",
            en: "Main Hall Use Agreement",
        },
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        version: 1,
    },
];
export const demoSpaceAvailabilityBlocks = [
    {
        id: "main-hall-2026-10-24-maintenance",
        blockId: "main-hall-2026-10-24-maintenance",
        organizationId: "org-hvicc",
        spaceId: "main-hall",
        type: "maintenance",
        startsAt: "2026-10-24T18:00:00.000Z",
        endsAt: "2026-10-24T20:00:00.000Z",
        label: "Maintenance hold",
        labelAr: "حجز صيانة",
        internalReason: "Development seed hold for floor setup checks.",
        publicReason: true,
        source: "experience_thirty_nine",
    },
    {
        id: "community-room-2026-10-24-admin-hold",
        blockId: "community-room-2026-10-24-admin-hold",
        organizationId: "org-rahma",
        spaceId: "community-room",
        type: "adminHold",
        startsAt: "2026-10-24T16:00:00.000Z",
        endsAt: "2026-10-24T18:00:00.000Z",
        label: "Staff hold",
        labelAr: "حجز إداري",
        internalReason: "Development seed hold for staff coordination.",
        publicReason: false,
        source: "experience_thirty_nine",
    },
];
export const demoSpaceReservationRequests = [
    {
        id: "spr_000000000000000000000040",
        approvedAt: null,
        cancellationReason: null,
        cancelledAt: null,
        cancelledBy: null,
        endsAt: "2026-10-17T20:00:00.000Z",
        guestCount: 45,
        notes: "Needs projector and chairs arranged in rows.",
        organizationId: "org-hvicc",
        purpose: "Youth halaqa and family dinner",
        rejectedAt: null,
        rejectionReason: null,
        requestedAt: "2026-08-09T12:00:00.000Z",
        requesterDisplayName: "HVICC Member",
        requesterEmail: "hvicc.member@example.test",
        requesterPersonId: "dev-hvicc-member",
        reservationId: "spr_000000000000000000000040",
        reviewedAt: null,
        reviewedBy: null,
        source: "experience_forty",
        spaceId: "main-hall",
        startsAt: "2026-10-17T18:00:00.000Z",
        status: "pending",
        timezone: "America/New_York",
    },
    {
        id: "spr_000000000000000000000041",
        approvedAt: "2026-08-09T13:00:00.000Z",
        cancellationReason: null,
        cancelledAt: null,
        cancelledBy: null,
        endsAt: "2026-10-03T21:00:00.000Z",
        guestCount: 60,
        notes: "Seeded approved reservation for schedule and conflict checks.",
        organizationId: "org-hvicc",
        purpose: "Community dinner setup",
        rejectedAt: null,
        rejectionReason: null,
        requestedAt: "2026-08-09T11:00:00.000Z",
        requesterDisplayName: "HVICC Member",
        requesterEmail: "hvicc.member@example.test",
        requesterPersonId: "dev-hvicc-member",
        reservationId: "spr_000000000000000000000041",
        reviewedAt: "2026-08-09T13:00:00.000Z",
        reviewedBy: "dev-hvicc-admin",
        source: "experience_forty",
        spaceId: "main-hall",
        startsAt: "2026-10-03T19:00:00.000Z",
        status: "approved",
        timezone: "America/New_York",
    },
];
export const demoSpaceReservationConflictLocks = [
    "20261003T190000Z",
    "20261003T191500Z",
    "20261003T193000Z",
    "20261003T194500Z",
    "20261003T200000Z",
    "20261003T201500Z",
    "20261003T203000Z",
    "20261003T204500Z",
].map((bucket) => ({
    endsAt: "2026-10-03T21:00:00.000Z",
    id: `sprlock_main-hall_${bucket}`,
    lockId: `sprlock_main-hall_${bucket}`,
    organizationId: "org-hvicc",
    reservationId: "spr_000000000000000000000041",
    source: "experience_forty",
    spaceId: "main-hall",
    startsAt: "2026-10-03T19:00:00.000Z",
    status: "active",
}));
export const demoSpaceAvailabilitySlots = [
    {
        id: "main-hall-2026-10-03-evening",
        organizationId: "org-hvicc",
        spaceId: "main-hall",
        label: "Main Hall evening reservation",
        labelAr: "حجز القاعة الرئيسية المسائي",
        startsAt: "2026-10-03T22:00:00.000Z",
        endsAt: "2026-10-04T01:00:00.000Z",
        amountCents: 22500,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
    {
        id: "main-hall-2026-10-10-evening",
        organizationId: "org-hvicc",
        spaceId: "main-hall",
        label: "Main Hall evening reservation",
        labelAr: "حجز القاعة الرئيسية المسائي",
        startsAt: "2026-10-10T22:00:00.000Z",
        endsAt: "2026-10-11T01:00:00.000Z",
        amountCents: 22500,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
    {
        id: "main-hall-2026-10-17-evening",
        organizationId: "org-hvicc",
        spaceId: "main-hall",
        label: "Main Hall evening reservation",
        labelAr: "حجز القاعة الرئيسية المسائي",
        startsAt: "2026-10-17T22:00:00.000Z",
        endsAt: "2026-10-18T01:00:00.000Z",
        amountCents: 22500,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
    {
        id: "community-room-2026-10-03-afternoon",
        organizationId: "org-rahma",
        spaceId: "community-room",
        label: "Community Room afternoon reservation",
        labelAr: "حجز غرفة المجتمع بعد الظهر",
        startsAt: "2026-10-03T18:00:00.000Z",
        endsAt: "2026-10-03T20:00:00.000Z",
        amountCents: 9000,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
    {
        id: "community-room-2026-10-10-afternoon",
        organizationId: "org-rahma",
        spaceId: "community-room",
        label: "Community Room afternoon reservation",
        labelAr: "حجز غرفة المجتمع بعد الظهر",
        startsAt: "2026-10-10T18:00:00.000Z",
        endsAt: "2026-10-10T20:00:00.000Z",
        amountCents: 9000,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
    {
        id: "community-room-2026-10-17-afternoon",
        organizationId: "org-rahma",
        spaceId: "community-room",
        label: "Community Room afternoon reservation",
        labelAr: "حجز غرفة المجتمع بعد الظهر",
        startsAt: "2026-10-17T18:00:00.000Z",
        endsAt: "2026-10-17T20:00:00.000Z",
        amountCents: 9000,
        currency: "usd",
        status: "available",
        source: "experience_five",
    },
];
export const demoAnnouncements = [
    {
        id: "weekly-community-update",
        organizationId: "org-hvicc",
        title: "Weekly Community Update",
        titleAr: "تحديث المجتمع الأسبوعي",
        body: "Join this week's programs, volunteer openings, and service updates from the HVICC team.",
        bodyAr: "تابع برامج هذا الأسبوع وفرص التطوع وتحديثات الخدمة من فريق HVICC.",
        audience: "connected_people",
        priority: "normal",
        status: "published",
        visibility: "connected",
        source: "experience_six",
        publishedAt: "2026-10-01T15:00:00.000Z",
    },
    {
        id: "family-service-update",
        organizationId: "org-rahma",
        title: "Family Service Update",
        titleAr: "تحديث خدمة العائلة",
        body: "Rahma's family service team shared volunteer notes, program reminders, and next steps.",
        bodyAr: "شارك فريق خدمة العائلة في رحمة ملاحظات التطوع وتذكيرات البرامج والخطوات القادمة.",
        audience: "connected_people",
        priority: "normal",
        status: "published",
        visibility: "connected",
        source: "experience_six",
        publishedAt: "2026-10-01T16:00:00.000Z",
    },
];
export const demoOrganizationContents = [
    {
        contentId: "ramadan-1448-message",
        organizationId: "org-hvicc",
        type: "ramadan_message",
        status: "published",
        visibility: "connected",
        title: "Ramadan at HVICC",
        titleAr: "رمضان في HVICC",
        subtitle: "Prepare for worship, Iftar, and community nights",
        subtitleAr: "استعد للعبادة والإفطار وليالي المجتمع",
        body: "Ramadan 1448 is open for planning. Review the prayer schedule, sponsor an Iftar date, and follow upcoming programs as the month approaches.",
        bodyAr: "رمضان 1448 مفتوح للتخطيط. راجع جدول الصلاة، وارعَ موعد إفطار، وتابع البرامج القادمة مع اقتراب الشهر.",
        image: {
            storagePath: "organizations/org-hvicc/content/ramadan-1448-message/ramadan.jpg",
            altText: "Ramadan welcome artwork for HVICC",
            altTextAr: "صورة ترحيبية برمضان في HVICC",
        },
        galleryImage1: null,
        galleryImage2: null,
        galleryImage3: null,
        youtube: {
            canonicalUrl: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
            videoId: "aqz-KE-bpKQ",
        },
        sortOrder: 5,
        featured: true,
        publishedAt: "2026-10-02T16:30:00.000Z",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "ramadan_mobile_v1",
    },
    {
        contentId: "imam-profile",
        organizationId: "org-hvicc",
        type: "imam_profile",
        status: "published",
        visibility: "connected",
        title: "Imam Profile",
        titleAr: "ملف الإمام",
        subtitle: "Guidance, teaching, and community care at HVICC",
        subtitleAr: "إرشاد وتعليم ورعاية مجتمعية في HVICC",
        body: "Meet the Imam and learn about the spiritual guidance, khutbahs, classes, and community support that HVICC offers through Shdeed.",
        bodyAr: "تعرّف على الإمام وخدمات الإرشاد والخطب والدروس والدعم المجتمعي التي يقدمها HVICC عبر شديد.",
        image: {
            storagePath: "organizations/org-hvicc/content/imam-profile/imam-profile.jpg",
            altText: "HVICC Imam profile image",
            altTextAr: "صورة ملف إمام HVICC",
        },
        galleryImage1: {
            storagePath: "organizations/org-hvicc/content/imam-profile/gallery/classroom.jpg",
            altText: "Imam teaching a community class",
            altTextAr: "الإمام يدرّس درساً مجتمعياً",
        },
        galleryImage2: {
            storagePath: "organizations/org-hvicc/content/imam-profile/gallery/care.jpg",
            altText: "Community care conversation",
            altTextAr: "جلسة رعاية مجتمعية",
        },
        galleryImage3: null,
        youtube: {
            canonicalUrl: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
            videoId: "aqz-KE-bpKQ",
        },
        sortOrder: 10,
        featured: true,
        publishedAt: "2026-10-02T17:00:00.000Z",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_twenty_two",
    },
    {
        contentId: "assistant-imam-profile",
        organizationId: "org-hvicc",
        type: "imam_profile",
        status: "published",
        visibility: "connected",
        title: "Assistant Imam Profile",
        titleAr: "ملف الإمام المساعد",
        subtitle: "Youth education and family programs",
        subtitleAr: "تعليم الشباب وبرامج الأسرة",
        body: "A second leadership profile demonstrates how centers with multiple Imams can present each person clearly in the Shdeed mobile app.",
        bodyAr: "يوضح ملف القيادة الثاني كيف يمكن للمراكز التي لديها أكثر من إمام عرض كل شخص بوضوح في تطبيق شديد.",
        image: {
            storagePath: "organizations/org-hvicc/content/assistant-imam-profile/assistant-imam-profile.jpg",
            altText: "HVICC assistant Imam profile image",
            altTextAr: "صورة ملف الإمام المساعد في HVICC",
        },
        galleryImage1: null,
        galleryImage2: null,
        galleryImage3: null,
        youtube: null,
        sortOrder: 20,
        featured: false,
        publishedAt: "2026-10-02T17:30:00.000Z",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_twenty_two",
    },
    {
        contentId: "imam-profile",
        organizationId: "org-rahma",
        type: "imam_profile",
        status: "published",
        visibility: "connected",
        title: "Community Scholar Profile",
        titleAr: "ملف العالم المجتمعي",
        subtitle: "Learning and family service guidance at Rahma",
        subtitleAr: "تعليم وإرشاد لخدمة العائلة في رحمة",
        body: "Rahma uses the same organization-owned content model to introduce spiritual leadership, classes, and care resources for connected families.",
        bodyAr: "تستخدم رحمة نموذج المحتوى المملوك للمؤسسة نفسه للتعريف بالقيادة الروحية والدروس وموارد الرعاية للعائلات المتصلة.",
        image: {
            storagePath: "organizations/org-rahma/content/imam-profile/imam-profile.jpg",
            altText: "Rahma community scholar profile image",
            altTextAr: "صورة ملف العالم المجتمعي في رحمة",
        },
        galleryImage1: null,
        galleryImage2: null,
        galleryImage3: null,
        youtube: null,
        sortOrder: 10,
        featured: true,
        publishedAt: "2026-10-02T18:00:00.000Z",
        createdAt: "development-seed",
        createdBy: "development-seed",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        source: "experience_twenty_two",
    },
];
const demoAnnouncementTimelineEntries = demoAnnouncements.map((announcement) => ({
    id: `announcement-${announcement.id}`,
    organizationId: announcement.organizationId,
    announcementId: announcement.id,
    eventId: null,
    volunteerOpportunityId: null,
    entryType: "announcement",
    title: announcement.title,
    titleAr: announcement.titleAr,
    body: announcement.body,
    bodyAr: announcement.bodyAr,
    priority: announcement.priority,
    expiresAt: announcement.expiresAt ?? null,
    status: "visible",
    visibility: announcement.visibility,
    source: announcement.source,
    publishedAt: announcement.publishedAt,
}));
const demoEventTimelineEntries = demoCommunityEvents
    .filter((event) => event.status === "published")
    .map((event) => ({
    id: `event-${event.eventId}`,
    organizationId: event.organizationId,
    announcementId: null,
    eventId: event.eventId,
    volunteerOpportunityId: null,
    entryType: "event",
    title: event.title,
    titleAr: event.titleAr,
    body: event.description,
    bodyAr: event.descriptionAr,
    priority: "normal",
    status: "visible",
    visibility: event.visibility,
    source: event.source,
    publishedAt: event.publishedAt ?? event.startsAt,
}));
const demoVolunteerTimelineEntries = demoVolunteerOpportunities
    .filter((opportunity) => opportunity.status === "published")
    .map((opportunity) => ({
    id: `volunteer-${opportunity.opportunityId}`,
    organizationId: opportunity.organizationId,
    announcementId: null,
    eventId: null,
    volunteerOpportunityId: opportunity.opportunityId,
    entryType: "volunteerOpportunity",
    title: opportunity.title,
    titleAr: opportunity.titleAr,
    body: opportunity.description,
    bodyAr: opportunity.descriptionAr,
    priority: "normal",
    status: "visible",
    visibility: opportunity.visibility,
    source: opportunity.source,
    publishedAt: opportunity.publishedAt ?? opportunity.startsAt ?? "development-seed",
}));
export const demoTimelineEntries = [
    ...demoAnnouncementTimelineEntries,
    ...demoEventTimelineEntries,
    ...demoVolunteerTimelineEntries,
];
const demoHviccCommunityFocusMode = {
    activatedAt: "2026-10-01T12:00:00.000Z",
    activationPolicy: "manualOrScheduled",
    archivedAt: null,
    createdAt: "development-seed",
    createdBy: "development-seed",
    deactivatedAt: null,
    displayName: {
        ar: "أسبوع تركيز المجتمع",
        en: "Community Focus Week",
    },
    endsAt: "2026-12-31T23:59:59.000Z",
    featureConfig: {
        requiredEntitlementIds: ["operations.modes"],
        requiredFeatureFlagIds: [],
    },
    home: {
        actionShortcutIds: ["acknowledgeUpdate", "viewEvents", "give"],
        countdownTargetAt: "2026-12-31T23:59:59.000Z",
        heroComponentId: "modeHero",
        pinnedRefs: [
            {
                collection: "timelineEntries",
                id: "announcement-weekly-community-update",
            },
            {
                collection: "events",
                id: "first-community-night",
            },
        ],
        prioritizedModuleIds: ["timeline", "events", "donations"],
        subtitle: "Weekly updates, community programs, and giving entry points are prioritized for connected people.",
        subtitleAr: "يتم إبراز التحديثات الأسبوعية والبرامج المجتمعية ونقاط التبرع للأشخاص المتصلين.",
        title: "Community Focus Week",
        titleAr: "أسبوع تركيز المجتمع",
    },
    id: "community-focus-week",
    modeId: "community-focus-week",
    navigation: {
        primaryModuleIds: ["timeline", "events", "donations"],
        quickActionIds: ["acknowledgeUpdate", "viewEvents", "give"],
    },
    organizationId: "org-hvicc",
    priority: 50,
    source: "experience_thirty_one",
    startsAt: "2026-10-01T00:00:00.000Z",
    status: "active",
    timeline: {
        emphasizedAnnouncementIds: ["weekly-community-update"],
        emphasizedEntryIds: ["announcement-weekly-community-update"],
        emphasizedEventIds: ["first-community-night"],
        priorityTags: ["normal"],
    },
    type: "seasonalCampaign",
    updatedAt: "development-seed",
    updatedBy: "development-seed",
    visibility: "connected",
};
const demoHviccServiceFocusDraftMode = {
    activatedAt: null,
    activationPolicy: "scheduled",
    archivedAt: null,
    createdAt: "development-seed",
    createdBy: "development-seed",
    deactivatedAt: null,
    displayName: {
        ar: "مسودة تركيز الخدمة",
        en: "Service Focus Draft",
    },
    endsAt: "2027-02-01T00:00:00.000Z",
    featureConfig: {
        requiredEntitlementIds: ["operations.modes"],
        requiredFeatureFlagIds: [],
    },
    home: {
        actionShortcutIds: ["viewEvents"],
        countdownTargetAt: "2027-02-01T00:00:00.000Z",
        heroComponentId: "eventFocus",
        pinnedRefs: [],
        prioritizedModuleIds: ["events", "timeline"],
        subtitle: "Draft mode used to verify that non-live configuration stays admin-only.",
        subtitleAr: "مسودة للتحقق من بقاء الإعدادات غير المنشورة للإدارة فقط.",
        title: "Service Focus Draft",
        titleAr: "مسودة تركيز الخدمة",
    },
    id: "service-focus-draft",
    modeId: "service-focus-draft",
    navigation: {
        primaryModuleIds: ["events"],
        quickActionIds: ["viewEvents"],
    },
    organizationId: "org-hvicc",
    priority: 20,
    source: "experience_thirty_one",
    startsAt: "2027-01-01T00:00:00.000Z",
    status: "draft",
    timeline: {
        emphasizedAnnouncementIds: [],
        emphasizedEntryIds: [],
        emphasizedEventIds: [],
        priorityTags: [],
    },
    type: "generic",
    updatedAt: "development-seed",
    updatedBy: "development-seed",
    visibility: "private",
};
const demoHviccRamadanSetupMode = {
    activatedAt: null,
    activationPolicy: "manualOrScheduled",
    archivedAt: null,
    createdAt: "development-seed",
    createdBy: "development-seed",
    deactivatedAt: null,
    displayName: {
        ar: "رمضان 1448",
        en: "Ramadan 1448",
    },
    endsAt: "2027-03-10T00:00:00.000Z",
    featureConfig: {
        requiredEntitlementIds: ["operations.modes", "ramadan.operations"],
        requiredFeatureFlagIds: [],
    },
    home: {
        actionShortcutIds: ["viewRamadan", "viewEvents", "give"],
        countdownTargetAt: "2027-03-09T23:59:59.000Z",
        heroComponentId: "modeHero",
        pinnedRefs: [
            {
                collection: "ramadan",
                id: "ramadan-1448",
            },
        ],
        prioritizedModuleIds: ["ramadan", "timeline", "events"],
        subtitle: "Ramadan dates, prayer overrides, Taraweeh, Qiyam, and last-ten-night emphasis are ready for activation.",
        subtitleAr: "تم تجهيز تواريخ رمضان وتعديلات الصلاة والتراويح والقيام وإبراز العشر الأواخر للتفعيل.",
        title: "Ramadan 1448 Setup",
        titleAr: "إعداد رمضان 1448",
    },
    id: "ramadan-1448-mode",
    modeId: "ramadan-1448-mode",
    navigation: {
        primaryModuleIds: ["ramadan", "timeline"],
        quickActionIds: ["viewRamadan"],
    },
    organizationId: "org-hvicc",
    priority: 90,
    source: "experience_thirty_one",
    startsAt: "2027-02-08T00:00:00.000Z",
    status: "draft",
    timeline: {
        emphasizedAnnouncementIds: [],
        emphasizedEntryIds: [],
        emphasizedEventIds: [],
        priorityTags: ["ramadan"],
    },
    type: "ramadan",
    updatedAt: "development-seed",
    updatedBy: "development-seed",
    visibility: "connected",
};
export const demoOperationalModes = [
    demoHviccCommunityFocusMode,
    demoHviccServiceFocusDraftMode,
    demoHviccRamadanSetupMode,
];
export const demoOperationalModeProjections = [
    {
        effectiveAt: "2026-10-02T12:00:00.000Z",
        id: "current",
        organizationId: "org-hvicc",
        primaryMode: {
            displayName: demoHviccCommunityFocusMode.displayName,
            endsAt: demoHviccCommunityFocusMode.endsAt,
            featureConfig: demoHviccCommunityFocusMode.featureConfig,
            home: demoHviccCommunityFocusMode.home,
            modeId: demoHviccCommunityFocusMode.modeId,
            navigation: demoHviccCommunityFocusMode.navigation,
            priority: demoHviccCommunityFocusMode.priority,
            startsAt: demoHviccCommunityFocusMode.startsAt,
            timeline: demoHviccCommunityFocusMode.timeline,
            type: demoHviccCommunityFocusMode.type,
            warnings: [],
        },
        source: "experience_thirty_one",
        status: "active",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        warnings: [],
    },
    {
        effectiveAt: "2026-10-02T12:00:00.000Z",
        id: "current",
        organizationId: "org-rahma",
        primaryMode: null,
        source: "experience_thirty_one",
        status: "normal",
        updatedAt: "development-seed",
        updatedBy: "development-seed",
        warnings: [],
    },
];
const demoAnnouncementEngagementDeliveryLogs = demoAnnouncements.map((announcement) => ({
    id: `announcement-${announcement.id}`,
    organizationId: announcement.organizationId,
    announcementId: announcement.id,
    eventId: null,
    channel: "in_app",
    audience: announcement.audience,
    provider: "mock_engagement_delivery",
    providerEventId: `mock_evt_engagement_${announcement.organizationId}_${announcement.id}`.replace(/[^A-Za-z0-9_]/g, "_"),
    status: "delivered_mock",
    source: announcement.source,
}));
const demoEventEngagementDeliveryLogs = demoCommunityEvents
    .filter((event) => event.notificationIntentId !== null)
    .map((event) => ({
    id: `event-${event.eventId}`,
    organizationId: event.organizationId,
    announcementId: null,
    eventId: event.eventId,
    channel: "in_app",
    audience: "connected_people",
    provider: "mock_engagement_delivery",
    providerEventId: `mock_evt_event_${event.organizationId}_${event.eventId}`.replace(/[^A-Za-z0-9_]/g, "_"),
    status: "delivered_mock",
    source: event.source,
}));
export const demoEngagementDeliveryLogs = [
    ...demoAnnouncementEngagementDeliveryLogs,
    ...demoEventEngagementDeliveryLogs,
];
export const demoOrganizationIntelligenceSnapshots = [
    {
        id: "latest-operational-pulse",
        organizationId: "org-hvicc",
        snapshotType: "operational_pulse",
        window: "development_seed",
        status: "ready",
        riskLevel: "watch",
        source: "experience_seven",
        generatedAt: "2026-10-02T12:00:00.000Z",
        title: "Operational pulse",
        titleAr: "نبض العمليات",
        summary: "HVICC has 11 connected people, 1 published event, $50 confirmed donations, 1 announcement, and active Ramadan and space availability.",
        summaryAr: "لدى HVICC أحد عشر شخصاً متصلاً وفعالية منشورة واحدة و50 دولاراً من التبرعات المؤكدة وإعلان واحد وجاهزية نشطة لرمضان والمساحات.",
        recommendation: "Ask connected people to acknowledge the weekly update before the next community program.",
        recommendationAr: "اطلب من الأشخاص المتصلين تأكيد قراءة التحديث الأسبوعي قبل البرنامج القادم.",
        connectedPeopleCount: 11,
        upcomingEventsCount: 1,
        confirmedDonationTotalCents: 5000,
        publishedAnnouncementsCount: 1,
        acknowledgementCount: 0,
        availableIftarSlotsCount: 3,
        availableSpaceSlotsCount: 3,
        activeSpacesCount: 1,
    },
    {
        id: "latest-operational-pulse",
        organizationId: "org-rahma",
        snapshotType: "operational_pulse",
        window: "development_seed",
        status: "ready",
        riskLevel: "watch",
        source: "experience_seven",
        generatedAt: "2026-10-02T12:15:00.000Z",
        title: "Operational pulse",
        titleAr: "نبض العمليات",
        summary: "Rahma has 4 connected people, 1 published event, $25 confirmed donations, 1 announcement, and active Ramadan and space availability.",
        summaryAr: "لدى رحمة أربعة أشخاص متصلين وفعالية منشورة واحدة و25 دولاراً من التبرعات المؤكدة وإعلان واحد وجاهزية نشطة لرمضان والمساحات.",
        recommendation: "Use the next family service update to invite more connected people before launch review.",
        recommendationAr: "استخدم تحديث خدمة العائلة القادم لدعوة المزيد من الأشخاص المتصلين قبل مراجعة الإطلاق.",
        connectedPeopleCount: 4,
        upcomingEventsCount: 1,
        confirmedDonationTotalCents: 2500,
        publishedAnnouncementsCount: 1,
        acknowledgementCount: 0,
        availableIftarSlotsCount: 3,
        availableSpaceSlotsCount: 3,
        activeSpacesCount: 1,
    },
];
export const demoPlatformOperationChecks = [
    {
        id: "development-seed-readiness-check",
        requestType: "environment_readiness",
        targetEnvironment: "development",
        status: "completed",
        source: "experience_eight",
        requestedAt: "2026-10-03T12:00:00.000Z",
        requestedBy: "dev-platform-super-admin",
        processedAt: "2026-10-03T12:00:05.000Z",
        processedBy: "system:completePlatformReadinessCheck",
        snapshotId: "latest-development-readiness",
        auditLogId: "development-seed-readiness-check",
    },
];
export const demoPlatformOperationSnapshots = [
    {
        id: "latest-development-readiness",
        snapshotType: "platform_readiness",
        targetEnvironment: "development",
        status: "ready",
        source: "experience_eight",
        generatedAt: "2026-10-03T12:00:05.000Z",
        generatedBy: "system:completePlatformReadinessCheck",
        readinessStatus: "ready_for_development",
        releaseGate: "main_to_staging_guarded",
        productionProtection: "manual_approval_required",
        secretPreflight: "not_configured_locally",
        organizationCount: 2,
        publicDirectoryCount: 2,
        activeConnectionCount: 15,
        platformSuperAdminCount: 1,
        auditLogCount: 1,
        summary: "Development operations are ready in the emulator with two synthetic organizations, one platform super admin, guarded staging deploys, and manual production approval.",
        summaryAr: "عمليات التطوير جاهزة في المحاكي مع مؤسستين تجريبيتين ومسؤول منصة واحد ونشر مرحلي محمي وموافقة إنتاج يدوية.",
        recommendation: "Keep production credentials unset locally and use the readiness check before launch hardening.",
        recommendationAr: "أبق بيانات اعتماد الإنتاج غير مفعلة محلياً واستخدم فحص الجاهزية قبل تقوية الإطلاق.",
    },
];
export const demoPlatformAuditLogs = [
    {
        id: "development-seed-readiness-check",
        actorUid: "dev-platform-super-admin",
        action: "platform_readiness_check",
        targetEnvironment: "development",
        source: "experience_eight",
        status: "completed",
        createdAt: "2026-10-03T12:00:05.000Z",
        createdBy: "system:completePlatformReadinessCheck",
        summary: "Completed seeded development readiness check for synthetic platform operations.",
    },
    {
        id: "staging-seed-launch-hardening-review",
        actorUid: "dev-platform-super-admin",
        action: "launch_hardening_review",
        targetEnvironment: "staging",
        source: "experience_nine",
        status: "completed",
        createdAt: "2026-10-04T12:00:05.000Z",
        createdBy: "system:completeLaunchReadinessReview",
        summary: "Completed seeded staging launch hardening review for synthetic release gates.",
    },
    {
        id: "hvicc-seed-migration-readiness-review",
        actorUid: "dev-platform-super-admin",
        action: "migration_readiness_review",
        targetEnvironment: "hvicc",
        source: "experience_ten",
        status: "completed",
        createdAt: "2026-10-05T12:00:05.000Z",
        createdBy: "system:completeMigrationReadinessReview",
        summary: "Completed seeded HVICC migration readiness review from read-only inventory.",
    },
    {
        id: "hvicc-seed-migration-mapping-review",
        actorUid: "dev-platform-super-admin",
        action: "migration_mapping_review",
        targetEnvironment: "hvicc",
        source: "experience_eleven",
        status: "completed",
        createdAt: "2026-10-06T12:00:05.000Z",
        createdBy: "system:completeMigrationMappingReview",
        summary: "Completed seeded HVICC migration mapping review from read-only inventory.",
    },
    {
        id: "production-seed-preflight-review",
        actorUid: "dev-platform-super-admin",
        action: "production_preflight_review",
        targetEnvironment: "production",
        source: "experience_twelve",
        status: "completed",
        createdAt: "2026-10-07T12:00:05.000Z",
        createdBy: "system:completeProductionPreflightReview",
        summary: "Completed seeded production access preflight without configuring credentials.",
    },
];
export const demoLaunchReadinessReviews = [
    {
        id: "staging-seed-launch-hardening-review",
        reviewType: "launch_hardening",
        targetEnvironment: "staging",
        status: "completed",
        source: "experience_nine",
        requestedAt: "2026-10-04T12:00:00.000Z",
        requestedBy: "dev-platform-super-admin",
        processedAt: "2026-10-04T12:00:05.000Z",
        processedBy: "system:completeLaunchReadinessReview",
        reportId: "latest-staging-launch-readiness",
        auditLogId: "staging-seed-launch-hardening-review",
    },
];
export const demoLaunchReadinessReports = [
    {
        id: "latest-staging-launch-readiness",
        reportType: "launch_readiness",
        targetEnvironment: "staging",
        status: "ready",
        source: "experience_nine",
        generatedAt: "2026-10-04T12:00:05.000Z",
        generatedBy: "system:completeLaunchReadinessReview",
        readinessDecision: "ready_for_staging_review",
        qualityGatePolicy: "docs_lint_test_security_build",
        productionApproval: "manual_approval_required",
        rollbackPlan: "documented",
        migrationReview: "no_production_migration",
        monitoringPlan: "synthetic_emulator_observability",
        platformReadinessStatus: "ready_for_development",
        platformSnapshotId: "latest-development-readiness",
        platformAuditLogCount: 1,
        requiredGateCount: 5,
        completedGateCount: 5,
        unresolvedIssueCount: 0,
        summary: "Staging launch hardening is ready for review with documented quality gates, rollback guidance, migration hold, synthetic monitoring, and manual production approval.",
        summaryAr: "تقوية الإطلاق للمرحلة جاهزة للمراجعة مع بوابات جودة موثقة وإرشادات رجوع وإيقاف للهجرة ومراقبة تجريبية وموافقة إنتاج يدوية.",
        recommendation: "Keep production blocked until Ahmed approves the staged build and real credential preflight.",
        recommendationAr: "أبق الإنتاج محظوراً حتى يوافق أحمد على بناء المرحلة وفحص بيانات الاعتماد الحقيقية.",
    },
];
export const demoMigrationReadinessReviews = [
    {
        id: "hvicc-seed-migration-readiness-review",
        reviewType: "hvicc_migration_readiness",
        target: "hvicc",
        targetOrganizationId: "org-hvicc",
        legacyFirebaseProjectId: "hvicc-76804",
        flutterFlowProjectId: "hvicc-7aaxis",
        status: "completed",
        source: "experience_ten",
        requestedAt: "2026-10-05T12:00:00.000Z",
        requestedBy: "dev-platform-super-admin",
        processedAt: "2026-10-05T12:00:05.000Z",
        processedBy: "system:completeMigrationReadinessReview",
        reportId: "latest-hvicc-migration-readiness",
        auditLogId: "hvicc-seed-migration-readiness-review",
    },
];
export const demoMigrationReadinessReports = [
    {
        id: "latest-hvicc-migration-readiness",
        reportType: "migration_readiness",
        target: "hvicc",
        targetOrganizationId: "org-hvicc",
        legacyFirebaseProjectId: "hvicc-76804",
        flutterFlowProjectId: "hvicc-7aaxis",
        status: "ready",
        source: "experience_ten",
        generatedAt: "2026-10-05T12:00:05.000Z",
        generatedBy: "system:completeMigrationReadinessReview",
        readinessDecision: "ready_for_mapping_review",
        dataPolicy: "read_only_no_copy",
        uidPolicy: "preserve_firebase_auth_uids",
        adminRolePolicy: "map_users_admin_to_hvicc_org_admin",
        authProviderCoverage: "email_password_google_apple_observed",
        firestoreRulesRisk: "requires_remediation",
        storagePolicyRisk: "requires_review",
        functionsInventoryRisk: "requires_review",
        launchReadinessDecision: "ready_for_staging_review",
        launchReportId: "latest-staging-launch-readiness",
        platformAuditLogCount: 3,
        requiredMappingCount: 8,
        completedMappingCount: 8,
        preservationCandidateCount: 12,
        blockerCount: 6,
        summary: "HVICC is ready for migration mapping review only: UID preservation, admin role mapping, and feature candidates are documented, while legacy rules, Storage, Functions source, Auth counts, and project linkage still require controlled review.",
        summaryAr: "HVICC جاهزة لمراجعة خريطة الهجرة فقط: تم توثيق حفظ معرفات UID وربط أدوار الإدارة ومرشحات الميزات، بينما ما زالت القواعد القديمة والتخزين ومصدر الوظائف وعدد حسابات المصادقة وربط المشروع تحتاج مراجعة مضبوطة.",
        recommendation: "Do not execute migration until PII-safe Auth counts, legacy rules remediation, Storage ownership, Functions replacement, and FlutterFlow-Firebase linkage are approved.",
        recommendationAr: "لا تنفذ الهجرة حتى تتم الموافقة على عد حسابات المصادقة بطريقة آمنة للبيانات، ومعالجة القواعد القديمة، وملكية التخزين، واستبدال الوظائف، وربط FlutterFlow مع Firebase.",
    },
];
export const demoMigrationMappingItems = [
    {
        key: "identity-users",
        legacySource: "users.uid, users.email, users.display_name, users.photo_url, users.phone_number",
        shdeedTarget: "people/{uid} and organizationConnections/{uid}/organizations/org-hvicc",
        status: "mapped",
        notes: "Preserve Firebase Authentication UID and connect migrated people only to HVICC.",
        notesAr: "احفظ معرف Firebase Authentication واربط الأشخاص المرحلين بمؤسسة HVICC فقط.",
    },
    {
        key: "admin-role",
        legacySource: "users.admin",
        shdeedTarget: "organizationConnections/{uid}/organizations/org-hvicc.role",
        status: "mapped",
        notes: "Map legacy admin users to HVICC organization admin, not platform admin.",
        notesAr: "اربط مسؤولي النظام القديم بدور مسؤول مؤسسة HVICC وليس مسؤول المنصة.",
    },
    {
        key: "prayer-iqama",
        legacySource: "global_config.iqama",
        shdeedTarget: "organizations/org-hvicc/prayerSettings/current",
        status: "mapped",
        notes: "Move iqama values behind server-authoritative organization prayer settings.",
        notesAr: "انقل قيم الإقامة إلى إعدادات صلاة خاصة بالمؤسسة وتدار من الخادم.",
    },
    {
        key: "updates",
        legacySource: "updates",
        shdeedTarget: "organizations/org-hvicc/announcements and timelineEntries",
        status: "mapped",
        notes: "Map update title, description, image, date, created time, and notification intent.",
        notesAr: "اربط العنوان والوصف والصورة والتاريخ ووقت الإنشاء ونية الإشعار.",
    },
    {
        key: "zikr",
        legacySource: "zikr",
        shdeedTarget: "organizations/org-hvicc/contentLibrary/zikr",
        status: "mapped",
        notes: "Preserve Arabic, English, and ordering fields for a future content-library module.",
        notesAr: "احفظ الحقول العربية والإنجليزية والترتيب لوحدة مكتبة المحتوى القادمة.",
    },
    {
        key: "ramadan-iftar",
        legacySource: "ramadan_iftar, iftar_id, registration",
        shdeedTarget: "organizations/org-hvicc/iftarSponsorshipSlots and sponsorship intents",
        status: "mapped",
        notes: "Map day, capacity, cuisine, payment state, admin notes, and transfer workflows.",
        notesAr: "اربط اليوم والسعة ونوع الطعام وحالة الدفع وملاحظات الإدارة وعمليات النقل.",
    },
    {
        key: "notifications-functions",
        legacySource: "ff_push_notifications, ff_user_push_notifications, send* functions, addFcmToken",
        shdeedTarget: "engagement delivery services, FCM token registry, and SES/FCM providers",
        status: "blocked",
        notes: "Requires controlled Functions source review before production notification replacement.",
        notesAr: "يتطلب مراجعة مضبوطة لمصدر الوظائف قبل استبدال إشعارات الإنتاج.",
    },
    {
        key: "payments-functions",
        legacySource: "initStripePayment, initStripeTestPayment",
        shdeedTarget: "Stripe and Stripe Connect webhook-backed commerce services",
        status: "blocked",
        notes: "Requires Stripe configuration review and verified webhook replacement before migration.",
        notesAr: "يتطلب مراجعة إعدادات Stripe واستبدالاً مؤكداً عبر webhooks قبل الهجرة.",
    },
    {
        key: "voice-generation",
        legacySource: "generateUpdateFromVoice",
        shdeedTarget: "future AI-assisted organization content workflow",
        status: "blocked",
        notes: "Requires provider, prompt, and privacy review before feature preservation.",
        notesAr: "يتطلب مراجعة المزود والتعليمات والخصوصية قبل حفظ هذه الميزة.",
    },
    {
        key: "storage-users",
        legacySource: "gs://hvicc-76804.appspot.com/users/**",
        shdeedTarget: "organization-scoped media ownership model",
        status: "blocked",
        notes: "Requires Storage path and ownership audit before file migration planning.",
        notesAr: "يتطلب تدقيق مسارات التخزين والملكية قبل تخطيط نقل الملفات.",
    },
    {
        key: "auth-provider-state",
        legacySource: "Firebase Authentication email/password, Google, Apple",
        shdeedTarget: "preserved Firebase Auth users in Shdeed projects",
        status: "blocked",
        notes: "Requires PII-safe production Auth counts before dry-run planning.",
        notesAr: "يتطلب عد حسابات المصادقة بطريقة آمنة للبيانات قبل تخطيط التجربة الجافة.",
    },
    {
        key: "flutterflow-linkage",
        legacySource: "FlutterFlow project hvicc-7aaxis and Firebase project hvicc-76804",
        shdeedTarget: "migration source registry",
        status: "blocked",
        notes: "Requires controlled confirmation that FlutterFlow is linked to the Firebase project.",
        notesAr: "يتطلب تأكيداً مضبوطاً بأن FlutterFlow مرتبط بمشروع Firebase.",
    },
];
export const demoMigrationMappingReviews = [
    {
        id: "hvicc-seed-migration-mapping-review",
        reviewType: "hvicc_migration_mapping",
        target: "hvicc",
        targetOrganizationId: "org-hvicc",
        legacyFirebaseProjectId: "hvicc-76804",
        flutterFlowProjectId: "hvicc-7aaxis",
        readinessReportId: "latest-hvicc-migration-readiness",
        status: "completed",
        source: "experience_eleven",
        requestedAt: "2026-10-06T12:00:00.000Z",
        requestedBy: "dev-platform-super-admin",
        processedAt: "2026-10-06T12:00:05.000Z",
        processedBy: "system:completeMigrationMappingReview",
        reportId: "latest-hvicc-migration-mapping",
        auditLogId: "hvicc-seed-migration-mapping-review",
    },
];
export const demoMigrationMappingReports = [
    {
        id: "latest-hvicc-migration-mapping",
        reportType: "migration_mapping",
        target: "hvicc",
        targetOrganizationId: "org-hvicc",
        legacyFirebaseProjectId: "hvicc-76804",
        flutterFlowProjectId: "hvicc-7aaxis",
        status: "ready",
        source: "experience_eleven",
        generatedAt: "2026-10-06T12:00:05.000Z",
        generatedBy: "system:completeMigrationMappingReview",
        mappingDecision: "ready_for_dry_run_planning",
        mappingSource: "hvicc_flutterflow_readonly_inventory",
        dataPolicy: "read_only_no_copy",
        readinessReportId: "latest-hvicc-migration-readiness",
        readinessDecision: "ready_for_mapping_review",
        identityMapping: "users_uid_to_people_and_connections",
        adminRoleMapping: "users_admin_to_hvicc_org_admin",
        prayerMapping: "global_config_iqama_to_org_prayer_settings",
        contentMapping: "updates_zikr_to_content_modules",
        ramadanMapping: "ramadan_iftar_registration_to_ramadan_workflows",
        functionMapping: "replace_flutterflow_functions_with_shdeed_services",
        storageMapping: "users_storage_path_requires_ownership_review",
        legacyCollectionCount: 8,
        legacyFunctionCount: 8,
        requiredMappingCount: demoMigrationMappingItems.length,
        completedMappingCount: demoMigrationMappingItems.filter((item) => item.status === "mapped")
            .length,
        blockedMappingCount: demoMigrationMappingItems.filter((item) => item.status === "blocked")
            .length,
        mappingItems: demoMigrationMappingItems,
        summary: "HVICC mapping is ready for dry-run planning only: identity, admin roles, prayer settings, updates, zikr, and Ramadan iftar structures have Shdeed destinations, while notifications, payments, voice generation, Storage ownership, Auth counts, and FlutterFlow linkage remain blockers.",
        summaryAr: "خريطة HVICC جاهزة لتخطيط تجربة جافة فقط: لدى الهوية وأدوار الإدارة وإعدادات الصلاة والتحديثات والذكر وبنى إفطار رمضان وجهات في شديد، بينما تبقى الإشعارات والمدفوعات وتوليد الصوت وملكية التخزين وعدد حسابات المصادقة وربط FlutterFlow عوائق.",
        recommendation: "Prepare a sanitized emulator dry run only after the remaining source-linkage, Auth-count, Storage, Functions, Stripe, and notification blockers are reviewed.",
        recommendationAr: "حضّر تجربة جافة معقمة في المحاكي فقط بعد مراجعة عوائق ربط المصدر وعد حسابات المصادقة والتخزين والوظائف وStripe والإشعارات.",
    },
];
export const demoProductionAccessItems = [
    {
        key: "github-production-reviewers",
        label: "GitHub production environment reviewers",
        status: "blocked",
        ownerAction: "Configure required reviewers on the GitHub production environment.",
        ownerActionAr: "اضبط المراجعين المطلوبين في بيئة الإنتاج على GitHub.",
    },
    {
        key: "firebase-projects",
        label: "Shdeed Firebase projects",
        status: "blocked",
        ownerAction: "Create or confirm shdeed-dev, shdeed-staging, and shdeed-prod.",
        ownerActionAr: "أنشئ أو أكد مشاريع shdeed-dev وshdeed-staging وshdeed-prod.",
    },
    {
        key: "firebase-deploy-token",
        label: "FIREBASE_DEPLOY_TOKEN",
        status: "blocked",
        ownerAction: "Add the deployment token only to GitHub environments after approval.",
        ownerActionAr: "أضف رمز النشر إلى بيئات GitHub فقط بعد الموافقة.",
    },
    {
        key: "firebase-web-api-key",
        label: "FIREBASE_WEB_API_KEY",
        status: "blocked",
        ownerAction: "Add environment-scoped Firebase web API keys in GitHub secrets.",
        ownerActionAr: "أضف مفاتيح Firebase web API المخصصة للبيئات في أسرار GitHub.",
    },
    {
        key: "stripe-production",
        label: "Stripe and Stripe Connect production credentials",
        status: "blocked",
        ownerAction: "Configure Stripe production keys and webhook secrets in a later commerce hardening run.",
        ownerActionAr: "اضبط مفاتيح Stripe الإنتاجية وأسرار webhooks في تشغيل لاحق لتقوية التجارة.",
    },
    {
        key: "ses-production",
        label: "Amazon SES sender and events",
        status: "blocked",
        ownerAction: "Verify SES sender domain, bounce, complaint, and delivery event handling later.",
        ownerActionAr: "تحقق لاحقاً من نطاق مرسل SES ومعالجة الارتداد والشكاوى وأحداث التسليم.",
    },
    {
        key: "app-store-google-play",
        label: "Apple and Google distribution credentials",
        status: "blocked",
        ownerAction: "Prepare mobile release credentials in a dedicated distribution run.",
        ownerActionAr: "حضّر بيانات اعتماد إصدار الجوال في تشغيل مخصص للتوزيع.",
    },
    {
        key: "migration-dry-run",
        label: "HVICC migration dry-run report",
        status: "blocked",
        ownerAction: "Complete a sanitized emulator migration dry run before production approval.",
        ownerActionAr: "أكمل تجربة هجرة جافة ومعقمة في المحاكي قبل موافقة الإنتاج.",
    },
    {
        key: "rollback-approval",
        label: "Rollback and cutover approval",
        status: "blocked",
        ownerAction: "Approve rollback instructions and cutover window before production.",
        ownerActionAr: "وافق على تعليمات الرجوع ونافذة الانتقال قبل الإنتاج.",
    },
];
export const demoProductionPreflightReviews = [
    {
        id: "production-seed-preflight-review",
        reviewType: "production_access_preflight",
        targetEnvironment: "production",
        migrationMappingReportId: "latest-hvicc-migration-mapping",
        status: "completed",
        source: "experience_twelve",
        requestedAt: "2026-10-07T12:00:00.000Z",
        requestedBy: "dev-platform-super-admin",
        processedAt: "2026-10-07T12:00:05.000Z",
        processedBy: "system:completeProductionPreflightReview",
        reportId: "latest-production-preflight",
        auditLogId: "production-seed-preflight-review",
    },
];
export const demoProductionPreflightReports = [
    {
        id: "latest-production-preflight",
        reportType: "production_preflight",
        targetEnvironment: "production",
        status: "ready",
        source: "experience_twelve",
        generatedAt: "2026-10-07T12:00:05.000Z",
        generatedBy: "system:completeProductionPreflightReview",
        preflightDecision: "blocked_until_owner_approval",
        credentialPolicy: "no_production_credentials_locally",
        productionDeploymentPolicy: "manual_workflow_dispatch_only",
        githubEnvironmentPolicy: "production_reviewers_required",
        firebaseProjectPolicy: "separate_dev_staging_prod_projects",
        migrationMappingReportId: "latest-hvicc-migration-mapping",
        migrationMappingDecision: "ready_for_dry_run_planning",
        requiredAccessItemCount: demoProductionAccessItems.length,
        readyAccessItemCount: demoProductionAccessItems.filter((item) => item.status === "ready")
            .length,
        blockedAccessItemCount: demoProductionAccessItems.filter((item) => item.status === "blocked")
            .length,
        accessItems: demoProductionAccessItems,
        summary: "Production remains blocked until Ahmed configures GitHub environment reviewers, Firebase deployment secrets, project confirmation, commerce, notifications, distribution, migration dry-run, rollback, and cutover approvals.",
        summaryAr: "يبقى الإنتاج محظوراً حتى يضبط أحمد مراجعي بيئة GitHub وأسرار نشر Firebase وتأكيد المشاريع والتجارة والإشعارات والتوزيع وتجربة الهجرة الجافة والرجوع وموافقات الانتقال.",
        recommendation: "Keep production credentials out of local development and configure them only in protected GitHub environments after owner approval.",
        recommendationAr: "أبق بيانات اعتماد الإنتاج خارج التطوير المحلي واضبطها فقط في بيئات GitHub المحمية بعد موافقة المالك.",
    },
];
export const demoConnectionRequests = [
    {
        id: "dev-prospect_org-hvicc",
        uid: "dev-prospect",
        organizationId: "org-hvicc",
        requestedRole: "connected_person",
        status: "pending_auto_accept",
        source: "welcome",
        locale: "en",
    },
    {
        id: "dev-prospect_org-rahma",
        uid: "dev-prospect",
        organizationId: "org-rahma",
        requestedRole: "connected_person",
        status: "pending_auto_accept",
        source: "welcome",
        locale: "en",
    },
];
export const roleLabels = {
    connectedPerson: "Connected person",
    communicationsAdmin: "Communications admin",
    eventCheckInStaff: "Event check-in staff",
    eventsAdmin: "Events admin",
    financeAdmin: "Finance admin",
    organizationAdmin: "Organization admin",
    organizationOwner: "Organization owner",
    spacesAdmin: "Spaces admin",
    volunteerCoordinator: "Volunteer coordinator",
};
export function findOrganization(organizationId) {
    return seedOrganizations.find((organization) => organization.id === organizationId);
}
export function findPublicOrganizationProfile(organizationId) {
    return publicOrganizationProfiles.find((organization) => organization.id === organizationId);
}
export function findPerson(uid) {
    return seedPeople.find((person) => person.uid === uid);
}
